/* ==========================================================================
   OYEGIFTS ADD-ON POPUP V12 — ADD-ONS + OPTIONAL SENDER/MESSAGE + CHECKOUT SAFETY
   - No login step after add-ons
   - Continue with Add-ons / Skip & Continue / Close / Overlay / Escape
     all save the main product + product properties + delivery details
   - Selected add-ons are added when selected; zero add-ons is also valid
   - OG_REDIRECT_TO_CHECKOUT = true  -> Shopify default /checkout
   - OG_REDIRECT_TO_CHECKOUT = false -> /cart
   - Redirect happens only after a successful cart write
============================================================================ */
(() => {
  'use strict';
  /* ============================================================
     FINAL DESTINATION TOGGLE
     true  = Shopify default checkout
     false = Cart page
  ============================================================ */
  const OG_REDIRECT_TO_CHECKOUT = true;
  if (window.OG_ADDON_POPUP_V9_LOADED) return;
  window.OG_ADDON_POPUP_V9_LOADED = true;
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const normalize = value => String(value || '').replace(/\s+/g, ' ').trim();
  const lower = value => normalize(value).toLowerCase();
  const DEFAULTS = {
    enabled: false,
    productFormSelector: 'form[action*="/cart/add"]',
    buyButtonSelector: 'button[name="add"], button[type="submit"], input[type="submit"], .product-form__submit, [data-add-to-cart], [data-product-submit]',
    categories: [],
    currentProductIsCourier: false,
    requireDeliverySelection: false,
    maxProductsPerSection: 50,
    maxSelectable: 50,
    currencySymbol: '₹',
    deliveryFeeProductId: 7579687125126,
    deliveryFeeVariantByAmount: {},
    deliveryFeeFallbackByType: {
      express: 49,
      fixed: 249,
      morning: 299,
      midnight: 349,
      standard: 0,
      remote: 0,
      next: 0
    }
  };
  const readConfig = () => {
    const node = $('#OgAddonPopupConfig');
    if (!node) return DEFAULTS;
    try {
      const custom = JSON.parse(node.textContent || '{}');
      return {
        ...DEFAULTS,
        ...custom,
        deliveryFeeFallbackByType: {
          ...DEFAULTS.deliveryFeeFallbackByType,
          ...(custom.deliveryFeeFallbackByType || {})
        }
      };
    } catch (error) {
      console.warn('[OG Add-ons] Invalid configuration:', error);
      return DEFAULTS;
    }
  };
  const config = readConfig();
  const popup = $('#OgAddonPopup');
  if (!popup || !config.enabled) return;
  const els = {
    dialog: $('.og-addon__dialog', popup),
    body: $('[data-og-addon-scroll]', popup),
    tabs: $('[data-og-addon-tabs]', popup),
    sections: $('[data-og-addon-sections]', popup),
    loading: $('[data-og-addon-loading]', popup),
    empty: $('[data-og-addon-empty]', popup),
    status: $('[data-og-addon-status]', popup),
    skip: $('[data-og-addon-skip]', popup),
    continueBtn: $('[data-og-addon-continue]', popup),
    details: $('[data-og-addon-details]', popup),
    detailsBack: $('[data-og-details-back]', popup),
    detailsClose: $('[data-og-details-close]', popup),
    detailsContinue: $('[data-og-details-continue]', popup),
    detailsSkip: $('[data-og-details-skip]', popup),
    detailsStatus: $('[data-og-details-status]', popup),
    senderName: $('[data-og-sender-name]', popup),
    hideName: $('[data-og-hide-name]', popup),
    senderPhone: $('[data-og-sender-phone]', popup),
    giftMessage: $('[data-og-gift-message]', popup),
    messageTabs: $('[data-og-message-tabs]', popup),
    messageOpen: $('[data-og-message-open]', popup),
    occasion: $('[data-og-occasion]', popup),
    occasionTrigger: $('[data-og-occasion-trigger]', popup),
    occasionLabel: $('[data-og-occasion-label]', popup),
    occasionMenu: $('[data-og-occasion-menu]', popup),
    messageModal: $('[data-og-message-modal]', popup),
    messageModalTitle: $('[data-og-message-modal-title]', popup),
    messageModalList: $('[data-og-message-modal-list]', popup),
    processing: $('[data-og-processing]', popup),
    processingTitle: $('[data-og-processing-title]', popup),
    processingSub: $('[data-og-processing-sub]', popup)
  };
  const state = {
    activeForm: null,
    activeVariantId: 0,
    activeProductHandle: '',
    renderedVariantId: -1,
    renderedProductHandle: '',
    productsByCategory: new Map(),
    productByVariant: new Map(),
    cardsByVariant: new Map(),
    renderedSections: [],
    selected: new Map(),
    loaded: false,
    loadingPromise: null,
    adding: false,
    activeCategory: '',
    bodyScrollY: 0,
    selectionSaveTimer: 0,
    selectionSaveIdle: 0,
    scrollRaf: 0,
    popupHideTimer: 0,
    imageObserver: null,
    cartSnapshot: null,
    cartPrefetchPromise: null,
    stage: 'addons',
    editOnly: false,
    detailsIncluded: true,
    completed: false,
    preparing: false,
    purchaseButton: null
  };
  const root = window.Shopify?.routes?.root || '/';
  const api = path => `${root.replace(/\/$/, '')}/${String(path).replace(/^\//, '')}`;
  const selectionKey = config.currentProductIsCourier
    ? 'og_addons_selected_courier_v9'
    : 'og_addons_selected_express_v9';
  const sharedSelectionKey = 'og_addons_shared_session_v2';
  const sharedSelectionPersistentKey = 'og_addons_shared_saved_v3';
  const transparentPixel = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
  /* ============================================================
     OPTIONAL SENDER + GIFT MESSAGE STEP
     - Opens after add-ons Continue / Skip / first Close
     - All fields are optional
     - Values stay in sessionStorage for the current browser tab
     - Final Continue / Skip / Close uses the existing verified cart flow
  ============================================================ */
  const senderSessionKey = 'og_sender_message_session_v1';
  const senderPersistentKey = 'og_sender_message_saved_v3';
  let senderMemory = {};
  let senderFieldsReady = false;
  let occasionChosen = false;
  const giftMessageGroups = [{"id":1,"name":"Congratulation","messages":["Congratulations on achieving a milestone at such a young age. I couldn’t have been happier for you. Stay blessed, dear.","Well, there was never a doubt in my heart regarding your hard work and dedication. Congratulations on your achievement, dear.","You have made us all proud, with your sincere determination and serious efforts. With the same spirit and zeal, you shall always make us proud! Well done and Congratulations on your success.","Facing challenges with strength, determination and confidence is what matters and you have done it! Congratulations on this amazing achievement!","I wish you a hearty congratulations on this pleasant occasion. May your life shower you with such happy and successful moments. Well Done. Congratulations","Congrats just seems like a small word, on all your efforts so good! You have reached the pinnacle of heights, so here is a touch wood! Get more success in years to come! Wishing you many congratulations on your big achievement!","You have made everyone extremely proud and proved your worth! I wish you success in everything that you do in life. Congratulations on your big day!","Just yesterday you were running around the house with your little feet and today you have graduated college with flying colors! Time flies so fast but we are so proud of you! Well Done & Many Congratulations!","In this competitive world, carving your place is a big deal! And you have outdone all your competitors and done that with zeal! Congrats on your big achievement!","Congrats on the birth of a baby boy! I wish you all the best as you embark on this beautiful journey of parenthood! It wont be easy as it looks though! But you will get through! Congratulations on becoming parents to the little bundle of joy!","Congratulations on your engagement! Life is a journey which becomes easy when you have someone to hold on to forever. May you both always be in love!","No dreams are too big if you take the first step in making them come true! Slow and steady yet determined you reached where you wanted to see the world from! Congratulations on your Big Day!"]},{"id":2,"name":"Get Well Soon","messages":["Seeing you like this has been the most difficult thing in my life but let me tell you that you are strong and beautiful. Get well soon, dear.","If hugs and kisses could cure, you would have been immune to everything by now! But since they don’t actually cure… Here is something to make you feel better... Get Well Soon Dear","Medicines will only cure your body but I promise that our friendship will heal your soul.. Get well soon my dear friend","If hugs and kisses could cure, you would have been immune to everything by now! But since they don’t actually cure… Here is something to make you feel better... Get Well Soon Dear","Here's hoping this little get well wish will give your spirits a great big lift! Wishing you a speedy recovery.. Get well soon my friend","While you rest and recover, I will be next to you, praying and hoping for a smooth and quick recovery.. I am by your side to take care of you and make you feel better","Sickness may make life seem all gloomy, like a dark night sky… but never forget that you are the star that lights up my life's skies! Here's wishing you a speedy recovery. Get Well Soon My Dear"]},{"id":3,"name":"Just Like That","messages":["Every day is special when you are around. So, here is a little gift to let you know that you are special."]},{"id":4,"name":"Love & Romance","messages":["Everything I do, I do it for you! This love that we have is rare and I promise to be with you forever! I cannot imagine a day without you! I love you!","With you by my side, I don't need anything ever! You are my sunshine, my ray of hope & my faith. Only if I could love you more than this! I love you forever till eternity!","If falling in love is so beautiful, I would want to fall every day! Need you to catch me in your arms and love me like you do!","After meeting you I understood what love songs really meant! You have given me a new life and I promise to be the best wife! I love you Darling!","Every time I think of you, my heart skips a beat! You make me weak in my knees with your touch and glance! I am so glad that I found you! I love you","Even the mere silence of love has the power to drown out all of life's chaos! Thank you for being my pillar of strength when I was not even able to stand up! I love you with all my heart","Even the mere silence of love has the power to drown out all of life's chaos! Thank you for being my pillar of strength when I was not even able to stand up! I love you with all my heart!","You are the first thing I think of each morning when I open my eyes and you are the last thing I think of each night when I close my eyes! And eventually everything in between! I love you","So far, in our journey together, every moment we have spent together has been awesome. But I promise you, that the best is yet to come! I love you my dear","How lucky I am to be able to spend my life with you, each day! Growing old together is what I look forward to each day with you! I love you","I want you to know that you are the only person I ever want to be with. I would rather cry with you than laugh with anyone else, because even crying with you makes me happy! I Love You…"]},{"id":5,"name":"New Born","messages":["On your new journey of being parents of a beautiful newborn, I want to wish you all the happiness in your life.","Congratulations to you and your entire family on the arrival of a baby! Have a wonderful journey of parenthood ahead.","We are so thrilled to congratulate you on your new baby. Have happy and wonder-filled times ahead.","Congratulations to the new mom and dad! We wish you a happy and exciting journey with your little one.","Congratulations on the arrival of your newest family member! We hope your parenthood is filled with loads of love, joy, and cuddles.","God has blessed you with a tiny miracle. Enjoy every moment of the parenthood with your little bundle of joy.","Congratulations on the newest addition to your family! Have a wonderful journey ahead full of exciting, remarkable, and life-changing events.","God has blessed you with a little life to look after. We wish you a wonderful and rewarding experience of parenthood ahead.","Congratulations on the arrival of your little treasure. We wish you all the best with babyhood and may it be filled with loads of joyous memories.","Wishing all the very best on the safe arrival of your new baby. May you find joy and happiness as proud new parents!","Sending you best wishes for the new blessing in your family. May your life be filled with much love, joy, and happiness in the coming time!"]},{"id":6,"name":"Cheer Up","messages":["You don’t need to wait for the summers to bloom because you are an evergreen Cactus that blooms everywhere, anytime."]},{"id":7,"name":"Appreciation","messages":["Every little thing you do in your life, you do it with utmost perfection. Are you even real? I feel blessed to have you in my life.","You always know how to make me laugh and lift my spirits. Thanks so much for being my friend!","Whenever something out of the ordinary happens, the first thing I think about is calling to tell you. That’s the sign of a great friend.","You’ve been by my side through so many ups and downs, and I want you to know that I’ll always do the same for you. Thank you!","You know you have found a true friend when you don’t need to be careful about what you say in front of them. Thank you for never judging me, friend.","Thank you for being the friend who never asks for reasons or explanations when all I need is a hug and a good laugh."]},{"id":8,"name":"Thank U","messages":["I have been loved so much by you. Hope to reciprocate the same some day. Till then, I want to thank you for loving me unconditionally.","Marriage is more than just a ceremony. It’s a promise that two souls make and fulfil. So, here is wishing you all the best for this new beginning in your life.","Thank you for being my biggest critic and teacher! If it weren't for you I would have never improved! Thank you for giving me your time and wisdom on several occasions.","Sometimes life gets so busy that we hardly find time to appreciate others and say Thank you! I want you to know that I am really thankful for all that you do for me…","I am so grateful to have a friend like you in my life. I don't know what I would have done without you. Thank you for tolerating me for so many years!","Whether it is the way you comforted me when I was down or the way in which your hugs magically wiped out my frowns, You have been there day after day, to make sure my life turned out this way!","You make happiness worth sharing, you make my dreams worth believing.. Thanks for being my friend, you make my life worth living"]},{"id":9,"name":"Wedding","messages":[]},{"id":10,"name":"Eid","messages":["May the God Almighty open the doors of happiness for you and fulfil all your dreams. Eid Mubarak to you and your family!","On this auspicious occasion of Eid, let's pay gratitude to the divine light for all the wonderful things in our lives. Eid Mubarak!","May this Eid fills your life with the brightest of colours. Here’s wishing you and your family a very happy Eid!","No matter where you are or what you are doing, remember that Allah is always with you to help and guide you in every important step of your life. Eid Mubarak!","Eid is a day of sharing what we have and caring for others. May you have a wonderful Eid this year!","Eid is the time of year when you should amend your mistakes and forgive others mistakes. May Allah on this day grants you wisdom and kindness!","May the God Almighty show you on the right path and help you in every step of your life. Eid Mubarak!","Sending you warm wishes and happiness on the occasion of Eid. Remember me in your prayers.","In every smile and laughter; In every silent prayer answered; In every opportunity that knocks your door – May Allah bless you!"]},{"id":11,"name":"Onam","messages":["I wish that this Onam fills your home and heart with happiness and joy! Happy Onam!","This Onam, I wish that the spirit of this auspicious festival stays with you in everything you do. Here's wishing you and you family a very happy Onam.","May the spirit of Onam bless you and your family. I wish that they guide you to success in your life. Happy Onam!","Wishing you happiness and joy this Onam. From our family, to yours.","May this auspicious festival and New Year bring happiness and prosperity to you. Here's wishing you a very Happy Onam!","This year I wish that the spirit of Onam stays with us for long time. Wish you a very Happy Onam!","On the auspicious occassion of Onam, I wish the colours and beautiful lights fill your home and heart with happiness and joy. Happy Onam!"]},{"id":12,"name":"Parents Day","messages":["Happy Parents Day, Mom and Dad! I am so lucky to have two blessings like you in my life!","Happy Parents Day to the best parents in the world! I am eternally grateful to both of you!","Nothing compares to the sacrifices our parents have made for us! Happy Parents Day to my parents!","Happy Parents Day! May you two live a long, happy, and peaceful life. Thank you for everything!","Happy Parents Day! No amount of appreciation is enough to express my gratefulness to you!","My dear parents, may you live long enough to fulfill all your wishes! Happy Parents Day!","Happy Parent’s Day! May both of you be blessed with twice the happiness you’ve brought into my life!","There is no greater love than a parent’s love for their child. Happy Parent’s Day!"]},{"id":13,"name":"Friendship Day","messages":["The greatest gift of life is friendship and I have received it. Happy Friendship day!","You are like a backbone to my life; I really am lucky to have you in my life. Happy Friendship Day!","Born lucky are those who have found the soulmate in their friend and you are much more than a friend to me. You are the epitome of friendship. Happy Friendship Day","You are not just my friend; you are my family which I choose. Happy Friendship Day!","Dear Bestie, The bond of friendship must be built on a rock solid foundation of alcohol, sarcasm, inappropriateness, and hating the same bunch of people, and you qualify all the parameters. Happy Friendship Day.","You know I am a compliment that God gave you years' after HE realized, you desperately need one? Happy Friendship's Day!","My bond we share is unbreakable. You are like a family now! Happy Friendship day.","Friendship is neither sold at the market, nor it is in your coat's pocket! It is a feeling dwelling in two hearts, whether near or miles apart! On this friendships day, I wish that you remain my friend till eternity! Happy Friends Day!","I cannot even imagine my life without you. I would have taken so many correct decisions had I not listened to you. But every wrong one has been awesome. Happy friendships day to my partner in crime.","Our gang is the best thing that has happened to me over the years! You guys are like my family- you scold me like my mom, love me like my sister and give me money like my dad! Thank u for always being there guys!","Friends like you are rare! Even God thought of not creating more samples after you! But for what its worth- I love you like no one else can! I know so much about you, enough to ruin your life!! Keep me happy always- Happy friendships day"]},{"id":14,"name":"Independence Day","messages":[]},{"id":15,"name":"Teacher's Day","messages":["I still miss those days when you used to punish me for not completing the home tasks...scold me for not paying proper attention to studies but, you were always the one who stayed relentless about giving the best education: the education of being a good man! Thanks for making me the person who I am today.","Happy teacher’s day. We can never thank you enough for your dedication, wisdom, and responsibility.","Happy Teachers’ Day to all the amazing teachers of the world!","Thank you for teaching me with kindness, dear teacher. Happy Teachers’ Day!","Happy teachers’ day! It has been an honour to get to learn so many things from you; thanks for inspiring me!","Dear teacher, without your guidance and wisdom, I wouldn’t be where I am right now! Thank you and Happy Teachers Day!","Happy Teachers’ Day to you! Your wisdom, dedication, and kindness will always lead us to the right path and inspire us to be better human beings.","Dear teacher, Wishing you a happy Teachers’ Day. Thank you for being the guiding light and for inspiring me to do well in my studies. You are the best teacher.","A good teacher is a way to success. I was lucky enough to meet you. You have been such a wonderful friend and my biggest support, and I can’t be more grateful to you. Happy Teachers’ Day!","Teaching is one profession that creates all other professions. Thank you for helping me become the person I am today. Happy Teachers’ Day!","Being your student is truly a blessing. I’ve learned so much from you. You are, hands down, the best teacher and an amazing person. Thank you for everything you do for all of your students. Happy Teachers’ Day!"]},{"id":16,"name":"Grandparent's Day","messages":["Staying around you is my ultimate favorite thing to do. I admire your never-ending love. Happy Grandparents' Day!","Happy Grandparents' Day! We love you, and you have our highest regard. Please be there, always!"]},{"id":17,"name":"Daughter's Day","messages":["“Wishing a very Happy Daughter’s Day to the most wonderful daughter in this world…. May you find happiness in everything you do, may you find success in your life.”","To our dearest daughter, we wish a very Happy Daughters Day. Always wear that beautiful smile because it brings us the greatest joys of life.","You have been a daughter who has filled our lives with much love, affection and happiness. We are happy to have you. Happy Daughters Day.","May you walk the path of success. May you enjoy each and every moment of your life. May you are always blessed. Warm wishes on Daughters Day.","Daughters are the angels sent by God into our lives…. Warm wishes on Daughter’s Day to my dearest daughter who completes this life.","A daughter is the most beautiful blessing from God, a blessing that brightens each and every day of our life…. Happy Daughter’s Day to my dearest daughter."]},{"id":18,"name":"Ganesh Chaturthi","messages":["May Lord Ganesha destroy all your worries, sorrows and tensions. Happy Ganesh Chaturthi!","Always pray for sharp ears like Ganesha to hear everything clear. Warm wishes on Ganesh Chaturthi","I pray that Ganesha bestows you with happiness, wisdom, good health and prosperity!","May Lord Ganesha always remove obstacles from your life. Happy Ganesha Chaturthi!","May Lord Ganesha bestow you power, destroy your sorrow and enhance happiness in your life.","I pray that Ganesha bestows you with happiness, wisdom, good health and prosperity!","May Lord Ganesha keep enlightening your lives and bless you always. Wishing you a Happy Vinayak Chaturthi!"]},{"id":19,"name":"Karwa Chauth","messages":["As I see the bright moon peeking through the clouds, I want to confess my love for you my dear spouse! Happy Karwa Chauth.","May the moon light flood your life with happiness and joy. May you always have peace and harmony in your life! Happy Karwa Chauth","May all your prayers for your husband's well being be answered today and always! Happy First Karwa Chauth to you both","On this Karwa Chauth, my love for you shines brighter than the moon. May your fast be easy, and may our love continue to grow stronger with each passing day.","As you look at the moon tonight, remember that my love for you is as eternal as its glow. Happy Karwa Chauth to the woman who makes my life complete!”","Your love is the light that guides me through my darkest days. This Karwa Chauth, I promise to cherish and adore you forever. Happy fasting, my darling!","Each moment with you is a blessing. As you fast for my long life, I pray for your happiness and well-being. Happy Karwa Chauth, my beautiful wife!”","Happy Karwa Chauth! Remember, no sneaking in snacks today! I promise to reward your patience with lots of love and some delicious treats later!","Wishing my lovely wife a day filled with love and some ‘dil se’ fasting! Can’t wait to celebrate our love under the moonlight!"]},{"id":20,"name":"Diwali","messages":["Best wishes and regards ahead of Diwali to you and your family.","On the occasion of Diwali, I wish you happiness and glory, prosperity and blessings. May you have a fantastic Diwali with your loved ones.","May the Goddess of wealth and the God of Knowledge bless you with their choicest blessings. Happy Diwali!!","May the merriment of this wonderful festival of Diwali fill your life with infinite joy. Happy Diwali to you and the ones who matter to you!","Jagmagata rahe aapka jeevan, Jhilmilata rahe aapka ghar, Bani rahe aapke adharon par meethi muskaan, Aur manate rahein aap Diwali har saal.","Light over darkness, hope or despair, and victory of good in the world. Happy Diwali","Shine like sparkles, glow like candles and burn all the negativity like crackles. Wish you all a very lovely & cheerful Diwali.","May you be blessed with happiness and well being to last through the year. Happy Diwali","May Maa Lakshmi shower you with her choicest blessings, and may you get rid of all your sorrows and agony this Diwali.","May the lights of Deepavali illuminate your life, and may you be blessed with Goddess Lakshmi's choicest blessings.","Wishing a very Happy Diwali to you. May the incredible charm of Diwali stay with you forever and keep showering you with happiness and smiles.","May the celebrations of Diwali fill your heart with eternal joys. May the festivities of Diwali brighten your life. A very Happy Diwali to you."]},{"id":21,"name":"Lohri","messages":[]},{"id":22,"name":"April Fool","messages":["* You are a gorgeous, amazing, intelligent talented, caring and an understanding person. Smiling? Well, Happy April Fool’s Day!","* If anyone calls you beautiful, If anyone appreciates you for no reason, If anyone thinks you are intelligent, Just smile and wish the person Happy April Fool’s Day!","*Happy April Fool’s Day, you fool. May you get some cheer and fun!","*Believe nothing and trust no one. Today is April Fool’s Day!","“If anyone thinks that you are smart then just smile at him and wish him a Happy April Fool’s Day and he would know it all.”"]},{"id":23,"name":"New Year","messages":["Wishing you all a very happy New Year! ...","Here's wishing you all a very happy New Year, from our family to yours!","May this new year bless you and your loved ones with good health, wealth, and happiness. Happy New Year!","Here’s to a new year that is full of happiness and unforgettable memories! Wish you a very happy new year!","May God give strength to you and bless you to achieve whatever you want in your life. Happy New Year!","A new year reminds you that no matter what happened in the past, you now have a whole new calendar to fill it with newer memories. Happy New Year!","May this new year bring you more success and happiness! Happy New Year!","Happy New Year to you, my friend. Let's make more fun-filled memories this year too!"]},{"id":24,"name":"Rakhi","messages":["You know that you are the most precious stone in the collection of my secret treasure..Wishing you very Happy Rakhi and best of luck for everything!","Throughout these years, you have done so many things for me. It helps me know deep down inside how much you care. I may not say it every day but I admire you a lot. I feel richly blessed to have someone like you as my sibling. Happy Raksha Bandhan.","The loving occasion of Raksha Bandhan is the best time to reminisce fondly the wonderful moments we have spent together, sharing each other's joys and sorrows. Thanks for spreading smiles and making life so beautiful and meaningful! Happy Rakhi","Being brother and sister means being there for each other. And I promise you will find me standing next to you through thick and thin.","It's all you who have kept all my secrets hidden and given me the wings to fly high! Thanks you Bhayia. Happy Raksha Bandhan.","You are the one with whom I can share anything without hesitation, be this amazing and supportive always. Happy Raksha Bandhan!","You never say no, you never say anything's impossible and you never say you can't. That's my brother, my superman who make things possible and who makes my life smoother. I love you my dear brother. Wishing you a Happy Raksha Bandhan","I miss those times when you scolded me for something I did or said wrong! The times you did my homework, the times you stood by me when I needed someone to lean on. Thank you so much my dear sister. Happy Rakhi to you!","The sacred bond of love which is unbreakable. We fight, we love and we can't live without each other. The best bro-sis duo is us. Happy Raksha Bandhan!","As the years go by, the love between a brother and sister multiplies with caring and sharing. On the occasion of Rakhi, I want to send my love and best wishes to you. You have always been my best friend!","Dear Brother, this Rakhi, I pray to God for your peace, happiness and prosperity. A warm and loving person like you deserves the best of life. Happy Rakhi.","You were always my best friend, looking out for me, making sure the path I travelled on was smooth. Even if I searched the world over, there cannot be a better brother than you. Wishing you life's best always.","I might not express my love for you often, but today on the occasion of Rakhi, I promise you that I'll always be there for you. Happy Raksha Bandhan!","To Sister You are the most precious gift to me, joy to soul, and friend for the lifetime Happy Rakshabandhan","A brother shares childhood memories and grown up dreams. You have been my strength and support all through these years. Happy Rakhi Bhai"]},{"id":25,"name":"Propose Day","messages":[]},{"id":26,"name":"Chocolate Day","messages":[]},{"id":27,"name":"Valentines Day","messages":["This Valentine's, I just want to say that I Love You very much. You have made my life a lot happy and awesome! Happy Valentine's my love.","The day I fell in love with you was the most awesome day! The entire journey after meeting you has been more than awesome! Happy Valentines baby!","Dreams do come true! How do I know that? Coz I found you and got to know you! You are everything my dreams were ever made of! Happy Valentine's my dear!","Love is a beautiful journey of togetherness which I have enjoyed with you. Happy Valentine's sweetheart!","Falling in love was never in my plan! But now that I have, I am enjoying every waking moment with you. I wanna create more memories with each passing day with you. Happy Valentine's Day Baby.","Thank you for coming in my life and teaching me what true love is! You have given me the most beautiful and precious thing in the whole world! And that is your love! Happy Valentine's Day baby.","I love you more than words can ever express! So here, sending you my love with this gift! Happy Valentine's day baby!"]},{"id":28,"name":"Hug Day","messages":[]},{"id":29,"name":"Kiss Day","messages":[]},{"id":30,"name":"Teddy Day","messages":[]},{"id":31,"name":"Promise Day","messages":[]},{"id":32,"name":"Rose Day","messages":[]},{"id":33,"name":"Holi","messages":["Wishing you a very happy and colorful Holi!","May the splash of colors bring joys to you and your family. ...","May the colors of joy, happiness, and prosperity fill you and your family. ...","The festival of love, joy, and happiness is back. Wishing everyone a very happy Holi!","Enjoy the day to the fullest because Holi comes just once a year.","May the splash of colors bring joys to you and your family. Have a happy Holi 2023!","May the colors of joy, happiness, and prosperity fill you and your family. Happy Holi 2023!","On the happy occasion of Holi, may your life always be filled with the colors of joy and happiness. Happy Holi 2023!","May God gift you colors of life, colors of joy, colors of happiness, colors of friendship, colors of love, and all the other colors you want to paint in your life. Happy Holi 2023.","May you be blessed with good health, wealth, long life, peace, happiness, and joy on the auspicious day of Holi. Happy Holi 2023!"]},{"id":34,"name":"Women's Day","messages":["Though I don't need a specific day to remind myself how lucky I am, I want to thank you for all that you do for me! Life is beautiful coz of you! Happy Women's Day!","You are a blessing in disguise! We fight a lot, we irritate each other but the fact is I cannot live without you! May God make our bond more strong. Happy Women's Day!","I thank my stars all the time coz they sent an Angel like you in my life. You gave wings to my thoughts and whatever I am today is coz of you! Happy Women's Day!","There cannot be a more beautiful soul than you. Strong, caring, loving and selfless are few words that describe you the best. Be as you are! Happy Women's Day!","I just wanna take a moment here and tell you that you are very special to me. My worries vanish when I am with you and my happiness doubles. Happy Women's Day!","She is a Dreamer, she is a believer, she is a doer, she is an achiever, and that she is “You”. Happy Women’s Day.","This day belongs to you. May you prosper and stood affirm in the course of life. Happy Women's Day.","Only a woman can almost die and give birth at the same time. Be proud to be a woman. Happy Women’s Day!","Happy Women's Day to strong, intelligent, talented and simply wonderful women! Don't ever forget that you are loved and appreciated.","Being a woman itself is a superpower. Happy Women's Day to the superhero in my life!","“Everything that I know is all because of you….. You are the mother every kid wishes to have….. With all my heart, wish you Happy International Women’s Day mom.\"","To all the incredible women in the world, shine on, not just today but every single day. Happy Women's Day."]},{"id":35,"name":"Mother's Day","messages":["Mamma &lt;3 Of all the gifts that life has offered, you are the greatest of them all.. Thank you for being so mom-derful, mamma :)","Your smile brightens each day and makes it better than the last. Happy Mother's Day, Mom!","I’m glad that you’re my mother because I’m not sure anyone else could have put up with me this long! Love you, Mom.","I feel so lucky to have you as my mom. Thanks for always believing in me and doing so much for me each day. Have a great Mother’s Day, you deserve to be spoiled!","It’s my time to tell you how fortunate and special I am to be blessed with a mother as caring, loving as you. Wish you a happy Mother’s Day, Mom!","Mom, thank you for being my anchor in this stormy sea of life. I love you and don’t know where I’d be without you. Have a great day today.","Happy Mother’s Day to my very own superhero and the No. 1 problem-solver in my life. I hope you have a great day!","Thanks for everything Mom, you really are one in a million! Love you!","Thanks for always helping me to remember what is important in life… and today it is you! You are the best!","Mom, you are the most outstanding woman in my life, and you’ll always be my number one. Have a very happy Mother’s Day!","Thank you for always being there, Mom. Happy Mother’s Day!","Happy Mother’s Day Mom! Although we’re far apart you are always in my heart. I love you and miss you more than words can say.","Best friends and the best mother ever; you are seriously a gift to me! I love you. Happy Mother’s day!"]},{"id":36,"name":"Father's Day","messages":["Dear Father,  On the scale of 1-10, I would definitely give you a million!  Hats off to the greatest father ever!","Happy Father's Day to the man who put the fear into all my dates and still treats me like a princess!","Happy Father’s Day! I might be taller than you now but I still look up to you. Love you Dad!","Sending you heartfelt appreciation on Father’s Day. It’s the least I can do considering all the grey hairs I’ve caused you.","I’m so proud to be your kid. I have the best dad and I love you so much! Happy Father's Day!","Over the years, you’ve taught me so many of the important things I know—including a few choice words for certain situations! Happy Father’s Day!","Happy Father's Day to my hero and role model. Thank you for everything you have done for our family. We love you with all our hearts.","Sending lots of love to the dad who did his best to keep me out of trouble… from the daughter who sure did have a knack for finding it!","No matter how old I get, Dad, I’ll always be that same little girl who loves you with all her heart. Happy Father’s Day!"]},{"id":37,"name":"Birthday","messages":["Every day with you is one great celebration but today is a little extra special. I love you baby. Happy, happy birthday.","You know every time you smile, it melts my heart. So, let me make you smile a little wider today because it's your birthday. Happy birthday, beautiful.","Birthdays are the perfect time to create memories of a lifetime! Wishing you happy moments and blessings on your special day! Happy Birthday","On this special day, I hope that you get all that your heart desires. Happiness, peace of mind, prosperity and good health. May you get all these together with special gifts! Happy Birthday","Wishing you all the great things in life, hope this day will bring you an extra share of all that makes you happiest! Happy Birthday","May your Birthday bring you good luck and fortune. But even more than that, may it bring you oodles of true love and friendship. Happy Birthday","May you have all the joy your heart can hold, all the smiles a day can bring, all the blessings a life can unfold. May you get best of everything in life. Happy Birthday","You are not getting a year older but a year wiser! May this day bring you lots of gifts, happiness and surprises! Sending you loads of love on your Birthday","I may not be the first one to wish you happy birthday, but I am surely going to be the one who wishes that all your dreams come true. Happy Birthday","On your Birthday, I wish for the stars for you! But since I can't go and get them, sending you love wrapped in this present! Happy Birthday Dear","Keep calm and be crazy, love, laugh and live it up because this is the oldest you have been and the youngest you will ever be again! Happy Birthday","You are a special someone who deserves everything in life! On your birthday I pray that you get all that you desire and dream of! Wishing you a fun filled happy birthday","I wish that for every extra candle on your birthday cake, you have an extra reason to smile! Cherishing the memories forever, here's wishing you a very happy birthday","I did not forget your birthday… I just wanted to make it last long!! Wish you a very happy belated birthday! Here is something to help you to forgive me!!","Some people just age with time.. You, my dear, have aged like a fine wine! Complex, zingy and full of kick! Wishing you a hungover birthday! Party hard!","With every page you turn in your life, there is a new story waiting to be told! On your birthday I wish that you never run out of stories! Happy Birthday","Happy Birthday Dear! May your birthday be extra special and may all your dreams come true because no one else in this whole wide world deserves it more than you.","Birthday is the best time for remembering special people like you, because you mean so much to me. And always will! For the sweet person you are; and the kind things that you do; May life's special blessings; Be yours all year through! Happy Birthday","We go way back in life and none of the awesome things that happened to me would have been possible if it wasn’t for you! I want to thank you for being born and loving me so much. Wish you a very happy birthday!","A party without a cake is just a meeting! Sending you your favorite cake for your crazy party and wishing you a sweet year ahead.","May your birthday be sweet as chocolates, fragrant as flowers and awesome as you are! Sending you loads of hugs, love and best wishes on your special day! Happy Birthday","A special person like you deserves the best that each day can bring! On your special day, I wish for your long and healthy life. Happy Birthday Dear!"]},{"id":38,"name":"Anniversary","messages":["You breathed life into me the day you entered my life. So, today give me the chance to reciprocate the half of it. Happy anniversary, love.","If I had to choose my life partner again, I would have still chosen you for you are the Best. Happy anniversary :)Love","I have forgotten everything about the day we met for the first time, because life has been a sweet dream since the moment you became mine! Happy Anniversary Darling","When I first saw you, I was not sure if you and I were meant to be together! But you took the first step and made me realize that we were! I love this journey and I am glad I chose you! Happy Anniversary Dear","They say matches are made in heaven, But they sure are planned on the Earth! You are perfect for each other just the way you are! Wishing you a blissful anniversary","May you both find true and lasting happiness in each other's arms as you both celebrate your love. Happy Anniversary to an extremely special couple!","Years will come and years will go, but what will remain is the love that you two have for each other. May you never fall short of 'I Love You's to give to each other! Happy Anniversary to the sweet couple","I may have forgotten our anniversary yet again this year but I never forget how lucky I am to have you in my life. You remind me that true love still exists forever. Happy Belated Anniversary Darling!","You came into my life and changed it forever! Made me a better person, taught me how to love and above all taught me how to love selflessly. Thank you for everything! Happy Anniversary Dear","The moment I saw you, I knew I had to be with you! Your sparkling smile made me fall in love with you and I am so lucky to have you in my life. Happy Anniversary Sweetheart!","I never knew what love was until I met you! You showed me light where I thought was only darkness. Thank you loving me so much over these years! Happy Anniversary Darling","I heard a lot of love songs but only understood them after getting married to you! You are my prince charming who made all my dreams come true! I love you… Happy Anniversary Dear","Knowing that you will be in all my tomorrows, makes my today so wonderful. I keep on thanking my lucky stars for the moment when I met you and fell in Love. Happy Anniversary Dear.","You make my world go round and yet complete it somehow! I wouldn't want it any other way with you! You are my life, my love and everything. Happy Anniversary","To be around you both is like being around love! So pure, energetic and abundant. May your love grow stronger with each passing day! Here's wishing the lovely couple a very happy anniversary","I never believed in soul mates until I met you! It was like a dream out of a Bollywood movie, so unreal yet so real! I could never imagine loving someone so much! Happy Anniversary Dear","The moment when I took your hand in mine, I knew it was till eternity and beyond. You make me feel complete! Thank you for choosing me as your better half! Happy Anniversary","My life always felt like a puzzle! Always incomplete.. You came in my life and I realized you were the only missing piece of the puzzle that I was looking for! Happy Anniversary Dear","My life always felt like a puzzle! Always incomplete.. You came in my life and I realized you were the only missing piece of the puzzle that I was looking for! Happy Anniversary Dear","All my life I was looking for love and then you came and my world went upside down. You make me feel so happy and loved! Could not have asked for a better partner! Happy Anniversary Dear","Love is like a soul dwelling in two hearts! Yours and mine forever. Happy Anniversary to the man of my dreams, love of my life and my everything!","A wedding anniversary is the celebration of love, trust, partnership, tolerance and selflessness! The order varies for any given year! Wishing the beautiful couple a very happy anniversary","They say that after a few years, marriage loses its charm! But with you around me, I can feel the magic in our relationship forever. You have made my life so beautiful. Happy Anniversary Dear"]},{"id":39,"name":"Miss You","messages":["I miss you like the deserts miss the rain, like the oceans miss the waves! I miss you like the day misses the stars, like the moon misses the night! Hope to see you soon","When I miss you, I read our old conversations and smile like a little boy, listen to songs that remind me of you and then miss you more!","I miss you as soon as I wake up, I miss you when I am about to sleep! I wish you are always here next to me! Sending you a surprise to tell you how much I miss you!","When we first met, I had no idea you would become this important to me! Now that you have, I miss you every second of the day! Come soon!","Someone asked me if I missed you… I did not answer and I just closed my eyes and walked away.. And whispered.. So much..","Missing someone is your heart's way of telling you that you love them the most! I just realized how much I miss you and want to be with you all the time","Distance never separate two hearts that really care, for our memories span the miles and in seconds we are there! But whenever I start feeling sad, because I miss you, I remind myself how lucky I am to have someone so special to miss.","When I miss you, I pray to God to keep you safe and sound.. You are so far away but you feel so near.. I miss you so much and hope to see you soon","I keep myself busy with things to do but every time I pause, I still think of you! You have spoilt me with your love and now there is no going back! Come soon - I miss you!","It hurts not having you close, but it would hurt even more not having you at all! I am sending my love wrapped with this present.. Hope it explains how much I miss you!"]},{"id":40,"name":"I am Sorry","messages":["I took for granted all our smiles, laughs and memories. I promise I will never do it again because they mean the world to me. I am sorry for hurting you…","Life has its own way of making you realize the value of friendship… I understood this after fighting with you and losing you.. I am sorry.. Please be my friend again","I never meant to hurt you as I love you so much but the situation I was in was really bad. I know I messed up but please if you can forgive me. I will make it up to you I promise. I am sorry dear","I am sorry for being jealous. It's just that I am afraid of losing the best thing that ever happened to me. Please forgive me…","I am really sorry that I forgot how special you are to me.. How important your love is for me… Please forgive me and give me a chance to show you how much you mean to me…","Please forgive me.. I know how angry you are and what you must be going through.. I hope you know how sorry I am for all that happened between us","I am sorry for taking you for granted for everything. I realize how much I fight with you on unnecessary things. Please forgive me and I promise to be a good person.","Sorry! I have made some mistakes, they rest in the past. But my love for you, will always last. Even though we are miles apart, Wanted to tell you 'sorry' from my heart!","Sometimes I say or do the wrong things at the wrong time though I never intend to hurt you.. But sometimes I know I do.. I don’t know how to make things better but I can start by saying.. I am really sorry..","I feel so incomplete without you since the day we fought.. I am really sorry from my heart and will never hurt you ever again. Please forgive me"]},{"id":41,"name":"Thinking of You","messages":["When the night creeps in and I am all lonely, I think of you! When the morning sun is up, I am still thinking of you! Hope to be with you soon","When I want to smile, I know exactly what to do.. I just close my eyes and think of you! And I have the biggest smile on my face! Just reminding that I am thinking of you!","I realized I was thinking of you and I began to wonder how long you had been on my mind. Then it occurred to me: Since I met you, you've never left","I go to sleep thinking of you and I wake up thinking of you. Whatever I do, I think of you.. I just can't seem to get you out of my mind..","I can go days without talking to you, months without seeing you, but not a second goes by that I don't think of you! You are always on my mind!"]},{"id":42,"name":"Best of Luck","messages":["Success comes only to those who believe in themselves and are not afraid to take risks. Keep working on your dream as it will happen soon! Best of Luck to you in your new venture!","I want to wish you good luck but I would rather wish that you excel in whatever you plan on doing in life. Your positive attitude will take you places. Best of Luck for this new phase","I want to wish you good luck but I would rather wish that you excel in whatever you plan on doing in life. Your positive attitude will take you places. Best of Luck for this new phase","You have worked incredibly hard on this and we are super proud of you. Wishing you best of luck so that you always have luck on your side!","As long as you have Hard work in your stride, Good Luck will always be by your side! Make It big and make us proud! All the best","The road may seem rough, life may seem tough! But for a smooth sailing, My good luck wishes are enough!"]},{"id":43,"name":"House Warming","messages":["As you both take the first step in your new house, I want to extend my heartiest wishes on this new journey. May you have an awesome time in your new place. Happy House Warming!","They say a house lets you make countless memories! On this day when you pack old memories and unwrap new ones, I want to wish you all the happiness and joy! Have an amazing House warming","They say a house lets you make countless memories! On this day when you pack old memories and unwrap new ones, I want to wish you all the happiness and joy! Have an amazing House warming","Moving to a new place is never easy! But when I look at you two- Home is where heart is and no matter where you live, you are going to make it awesome. Happy House warming day!","As you move to a new address, I hope that you have a good time, filled with fun, food and wine! Don’t forget the old friends as you make new ones! Happy House warming day"]},{"id":44,"name":"Sympathy & Funerals","messages":["We are deeply sorry for your loss. May the departed soul rest in peace.","It’s terrible to hear about your loss. My deepest condolences to the deceased soul.","We extend deepest sympathies to you and your family. May the heavenly soul of your dear one be at peace.","We are saddened to learn about your loss. Please know that we are with you at this time of sorrow and extend our prayers to the departed soul.","We know that no amount of words can ease the loss you bear. But we just want to let you know that you’ll always be in our thoughts and prayers.","Please accept my condolences on the demise of your dear one. Just know that I am here if you ever need anything and don’t hesitate to reach out.","Saying goodbye to someone close to your heart is hard. May God bless you with strength and comfort to cope with this difficult time!","Saying goodbye to someone close to your heart is hard. May God bless you with strength and comfort to cope with this difficult time!","Words seem short to express our sadness on hearing this tragic news. Always remember we are here to support you in the difficult time of grief.","Please accept my sincere condolences on the loss of your dear one. May God bless their soul and bless you with courage and strength at this time of sorrow.","Our heart is saddened by your loss and we are sending our heartfelt condolences to you and your family. Please know that our thoughts and prayers are always with you."]},{"id":45,"name":"Christmas","messages":["It is the season for giving and sharing love. Christmas is a time when we take stock of our blessings and reach out to those who have touched our lives. Thank you for being such a wonderful person. The best of the Christmas season to you.","May the spirit of the season bring you closer to those whom you cherish so much. May this be a year of celebrations for everyone, Merry Christmas to you.","Christmas is a time for cherishing those who bring so many blessings to our lives. May your heart feel that love this Christmas and throughout the New Year ahead."]}];
  let activeGiftMessageGroup = 'Birthday';
  const hasSenderContent = value => !!value && (
    [value.senderName, value.senderPhone, value.giftMessage].some(item => normalize(item)) ||
    (value.occasionChosen === true && normalize(value.occasion) && value.occasion !== 'All')
  );
  const senderScore = value => {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return -1;
    let score = 0;
    if (normalize(value.senderName)) score += 4;
    if (normalize(value.senderPhone)) score += 3;
    if (String(value.giftMessage || '').trim()) score += 4;
    if (value.occasionChosen === true && normalize(value.occasion) && value.occasion !== 'All') score += 2;
    if (value.hideName === true) score += 1;
    return score;
  };
  const parseStoredObject = raw => {
    if (!raw) return null;
    try {
      const value = JSON.parse(raw);
      return value && typeof value === 'object' && !Array.isArray(value) ? value : null;
    } catch (error) { return null; }
  };
  const readSenderSession = () => {
    let persistent = null;
    let session = null;
    try { persistent = parseStoredObject(localStorage.getItem(senderPersistentKey)); } catch (error) {}
    try { session = parseStoredObject(sessionStorage.getItem(senderSessionKey)); } catch (error) {}
    const candidates = [persistent, session, senderMemory]
      .filter(value => value && typeof value === 'object' && !Array.isArray(value));
    let value = candidates.sort((a, b) => senderScore(b) - senderScore(a))[0] || {};
    if (value.occasionChosen === undefined) value.occasionChosen = !!normalize(value.occasion);
    senderMemory = { ...value };
    if (hasSenderContent(senderMemory)) {
      try { localStorage.setItem(senderPersistentKey, JSON.stringify(senderMemory)); } catch (error) {}
      try { sessionStorage.setItem(senderSessionKey, JSON.stringify(senderMemory)); } catch (error) {}
    }
    return senderMemory;
  };
  const saveSenderSession = () => {
    // Only the visible sender/message step may write field values.
    // Background refreshes and checkout preparation only read the saved object.
    if (!senderFieldsReady || popup.hidden || state.stage !== 'details') return readSenderSession();
    const value = {
      senderName: normalize(els.senderName?.value || ''),
      hideName: !!els.hideName?.checked,
      senderPhone: normalize(els.senderPhone?.value || ''),
      giftMessage: String(els.giftMessage?.value || '').trim(),
      occasion: activeGiftMessageGroup || 'Birthday',
      occasionChosen
    };
    senderMemory = value;
    try { localStorage.setItem(senderPersistentKey, JSON.stringify(value)); } catch (error) {}
    try { sessionStorage.setItem(senderSessionKey, JSON.stringify(value)); } catch (error) {}
    state.detailsIncluded = true;
    renderSummary();
    return value;
  };
  const restoreSenderSession = () => {
    const value = readSenderSession();
    activeGiftMessageGroup = value.occasion || 'Birthday';
    occasionChosen = value.occasionChosen === true;
    if (els.senderName) els.senderName.value = value.senderName || '';
    if (els.hideName) els.hideName.checked = !!value.hideName;
    if (els.senderPhone) els.senderPhone.value = value.senderPhone || '';
    if (els.giftMessage) els.giftMessage.value = value.giftMessage || '';
    senderFieldsReady = true;
  };
  const setFormProperty = (form, key, value) => {
    if (!form) return;
    const clean = String(value || '').trim();
    const existing = Array.from(form.querySelectorAll('[data-og-message-property]'))
      .find(node => node.dataset.ogMessageProperty === key);
    if (!clean) {
      existing?.remove();
      return;
    }
    const input = existing || document.createElement('input');
    input.type = 'hidden';
    input.name = `properties[${key}]`;
    input.dataset.ogMessageProperty = key;
    input.value = clean;
    if (!existing) form.appendChild(input);
  };
  const applySenderProperties = (includeDetails = true) => {
    const value = includeDetails ? saveSenderSession() : readSenderSession();
    // Skip does not delete previously saved sender details. Clear fields through Change to remove them.
    state.detailsIncluded = includeDetails || hasSenderContent(value);
    const form = state.activeForm;
    if (!form) return;
    if (!state.detailsIncluded) {
      Array.from(form.querySelectorAll('[data-og-message-property]')).forEach(node => node.remove());
      return;
    }
    setFormProperty(form, 'Sender Name', value.senderName);
    setFormProperty(form, 'Hide Sender Name', value.hideName ? 'Yes' : '');
    setFormProperty(form, 'Sender Phone Number', value.senderPhone);
    setFormProperty(form, 'Occasion', value.occasion && value.occasion !== 'All' && hasSenderContent(value) ? value.occasion : '');
    setFormProperty(form, 'Gift Message', value.giftMessage);
  };
  const setDetailsStatus = (message = '') => {
    if (!els.detailsStatus) return;
    els.detailsStatus.textContent = message;
    els.detailsStatus.hidden = !message;
  };
  const messageGroupByName = name => giftMessageGroups.find(group => lower(group?.name) === lower(name));
  const activeGiftMessages = () => {
    const group = messageGroupByName(activeGiftMessageGroup);
    return (group?.messages || []).filter(Boolean);
  };
  const hasChosenOccasion = () => activeGiftMessageGroup && activeGiftMessageGroup !== 'All';
  const messagePromptText = () => hasChosenOccasion()
    ? `Try One Of Our ${activeGiftMessageGroup} Suggested Messages`
    : '';
  const messageModalTitleText = () => hasChosenOccasion()
    ? `${activeGiftMessageGroup} Suggested Messages`
    : 'Suggested Messages';
  const closeGiftMessageModal = () => {
    if (!els.messageModal) return;
    els.messageModal.hidden = true;
    els.messageModal.setAttribute('aria-hidden', 'true');
    popup.classList.remove('is-message-modal-open');
  };
  const openGiftMessageModal = () => {
    if (!hasChosenOccasion() || !els.messageModal || !els.messageModalList) return;
    const messages = activeGiftMessages();
    if (els.messageModalTitle) els.messageModalTitle.textContent = messageModalTitleText();
    els.messageModalList.innerHTML = '';
    if (!messages.length) {
      const empty = document.createElement('p');
      empty.className = 'og-addon__message-modal-empty';
      empty.textContent = 'No suggested messages are available for this occasion.';
      els.messageModalList.appendChild(empty);
    } else {
      messages.forEach(message => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'og-addon__message-modal-item';
        button.textContent = message;
        button.addEventListener('click', () => {
          if (els.giftMessage) {
            els.giftMessage.value = message;
            saveSenderSession();
          }
          closeGiftMessageModal();
          window.requestAnimationFrame(() => els.giftMessage?.focus({ preventScroll: true }));
        });
        els.messageModalList.appendChild(button);
      });
    }
    els.messageModal.hidden = false;
    els.messageModal.setAttribute('aria-hidden', 'false');
    popup.classList.add('is-message-modal-open');
    window.requestAnimationFrame(() => {
      $('.og-addon__message-modal-close', els.messageModal)?.focus({ preventScroll: true });
    });
  };
  const populateOccasionMenu = () => {
    if (!els.occasionMenu || els.occasionMenu.dataset.ready === '1') return;
    const names = giftMessageGroups
      .map(group => normalize(group?.name))
      .filter(name => name && !/^birthday$/i.test(name) && !/^anniversary$/i.test(name))
      .sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
    ['All', ...names].forEach(name => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'og-addon__occasion-option';
      button.dataset.ogOccasionOption = name;
      button.innerHTML = `<span>${escapeHtml(name)}</span><span class="og-addon__occasion-check" aria-hidden="true">✓</span>`;
      els.occasionMenu.appendChild(button);
    });
    els.occasionMenu.dataset.ready = '1';
  };
  const closeOccasionMenu = () => {
    if (!els.occasionMenu || !els.occasionTrigger) return;
    els.occasionMenu.hidden = true;
    els.occasionTrigger.setAttribute('aria-expanded', 'false');
  };
  const openOccasionMenu = () => {
    if (!els.occasionMenu || !els.occasionTrigger) return;
    populateOccasionMenu();
    els.occasionMenu.hidden = false;
    els.occasionTrigger.setAttribute('aria-expanded', 'true');
  };
  const updateOccasionChecks = () => {
    $$('[data-og-occasion-option]', popup).forEach(button => {
      const selected = lower(button.dataset.ogOccasionOption) === lower(activeGiftMessageGroup || 'All');
      button.classList.toggle('is-selected', selected);
    });
  };
  const updateGiftMessageUI = () => {
    const isBirthday = activeGiftMessageGroup === 'Birthday';
    const isAnniversary = activeGiftMessageGroup === 'Anniversary';
    const isOther = activeGiftMessageGroup && !isBirthday && !isAnniversary && activeGiftMessageGroup !== 'All';
    $$('[data-og-message-tab]', popup).forEach(button => {
      const key = button.dataset.ogMessageTab || '';
      button.classList.toggle('is-active',
        (key === 'Birthday' && isBirthday) ||
        (key === 'Anniversary' && isAnniversary)
      );
    });
    if (els.occasionTrigger) els.occasionTrigger.classList.toggle('is-active', isOther);
    if (els.occasionLabel) els.occasionLabel.textContent = isOther ? activeGiftMessageGroup : 'All';
    updateOccasionChecks();
    if (els.messageOpen) {
      const text = messagePromptText();
      els.messageOpen.textContent = text;
      els.messageOpen.hidden = !text;
    }
  };
  const setGiftMessageGroup = name => {
    activeGiftMessageGroup = name || 'Birthday';
    closeGiftMessageModal();
    closeOccasionMenu();
    updateGiftMessageUI();
  };
  const showSenderStep = () => {
    if (!els.details || state.adding) return;
    state.stage = 'details';
    restoreSenderSession();
    setDetailsStatus('');
    popup.classList.add('is-details');
    els.details.setAttribute('aria-hidden', 'false');
    setGiftMessageGroup(activeGiftMessageGroup);
    window.requestAnimationFrame(() => els.senderName?.focus({ preventScroll: true }));
  };
  const showAddonStep = () => {
    if (!els.details || state.adding) return;
    saveSenderSession();
    state.stage = 'addons';
    popup.classList.remove('is-details');
    els.details.setAttribute('aria-hidden', 'true');
    window.requestAnimationFrame(() => els.continueBtn?.focus({ preventScroll: true }));
  };
  const resetSenderStep = () => {
    state.stage = 'addons';
    popup.classList.remove('is-details');
    closeGiftMessageModal();
    els.details?.setAttribute('aria-hidden', 'true');
    restoreSenderSession();
    setDetailsStatus('');
  };
  [els.senderName, els.senderPhone, els.giftMessage].forEach(input => {
    input?.addEventListener('input', saveSenderSession);
    input?.addEventListener('change', saveSenderSession);
  });
  els.hideName?.addEventListener('change', saveSenderSession);
  els.messageTabs?.addEventListener('click', event => {
    const button = event.target.closest('[data-og-message-tab]');
    if (!button) return;
    event.preventDefault();
    setGiftMessageGroup(button.dataset.ogMessageTab || 'Birthday');
    occasionChosen = true;
    saveSenderSession();
  });
  els.occasionTrigger?.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    if (els.occasionMenu?.hidden) openOccasionMenu();
    else closeOccasionMenu();
  });
  els.occasionMenu?.addEventListener('click', event => {
    const option = event.target.closest('[data-og-occasion-option]');
    if (!option) return;
    event.preventDefault();
    event.stopPropagation();
    activeGiftMessageGroup = normalize(option.dataset.ogOccasionOption || 'All') || 'All';
    occasionChosen = activeGiftMessageGroup !== 'All';
    closeGiftMessageModal();
    closeOccasionMenu();
    updateGiftMessageUI();
    saveSenderSession();
  });
  document.addEventListener('click', event => {
    if (!els.occasion || els.occasion.contains(event.target)) return;
    closeOccasionMenu();
  });
  els.messageOpen?.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    openGiftMessageModal();
  });
  els.messageModal?.addEventListener('click', event => {
    const close = event.target.closest('[data-og-message-modal-close]');
    if (!close) return;
    event.preventDefault();
    event.stopPropagation();
    closeGiftMessageModal();
  });
  const escapeHtml = value => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
  const priceNumber = value => {
    if (value === null || value === undefined) return 0;
    const original = String(value);
    const parsed = Number(original.replace(/,/g, '').replace(/[^\d.]/g, ''));
    if (!Number.isFinite(parsed)) return 0;
    if (!original.includes('.') && Number.isInteger(parsed) && parsed >= 10000) return parsed / 100;
    return parsed;
  };
  let inrFormatter = null;
  try {
    inrFormatter = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 2
    });
  } catch (error) {
    inrFormatter = null;
  }
  const money = value => {
    const amount = priceNumber(value);
    if (inrFormatter) return inrFormatter.format(amount).replace(/\.00$/, '');
    return `${config.currencySymbol}${amount.toFixed(amount % 1 ? 2 : 0)}`;
  };
  const show = element => {
    if (element) element.hidden = false;
  };
  const hide = element => {
    if (element) element.hidden = true;
  };
  const setStatus = (message = '', type = '') => {
    if (!els.status) return;
    if (!message && els.status.hidden) return;
    els.status.textContent = message;
    els.status.className = `og-addon__status${type ? ` is-${type}` : ''}`;
    els.status.hidden = !message;
  };
  const postJson = async (url, payload) => {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.description || data.message || 'Something went wrong.');
    return data;
  };
  const fetchCart = async () => {
    const response = await fetch(api('/cart.js'), {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Cart could not be verified.');
    return response.json();
  };
  const prefetchCart = () => {
    if (state.cartSnapshot) return Promise.resolve(state.cartSnapshot);
    if (state.cartPrefetchPromise) return state.cartPrefetchPromise;
    state.cartPrefetchPromise = fetchCart()
      .then(cart => {
        state.cartSnapshot = cart;
        return cart;
      })
      .finally(() => {
        state.cartPrefetchPromise = null;
      });
    return state.cartPrefetchPromise;
  };
  const clearCartSnapshot = () => {
    state.cartSnapshot = null;
    state.cartPrefetchPromise = null;
  };
  const getCurrentHandle = () => {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    return match ? match[1] : '';
  };
  const getVariantId = form => Number(form?.querySelector('[name="id"]')?.value || 0);
  const getQuantity = form => {
    const quantity = parseInt(form?.querySelector('[name="quantity"]')?.value || '1', 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  };
  const getSellingPlan = form => normalize(form?.querySelector('[name="selling_plan"]')?.value || '');
  const readFormProperties = form => {
    const properties = {};
    if (!form) return properties;
    for (const [name, rawValue] of new FormData(form).entries()) {
      const match = String(name).match(/^properties\[(.+)]$/);
      if (!match || typeof rawValue !== 'string') continue;
      const value = normalize(rawValue);
      if (value) properties[match[1]] = value;
    }
    return properties;
  };
  const readValue = selectors => {
    for (const selector of selectors) {
      const node = $(selector);
      if (!node) continue;
      const value = normalize(node.value || node.dataset?.value || node.textContent || '');
      if (value) return value;
    }
    return '';
  };
  const summaryText = () => $$([
    '.og-selected-delivery',
    '[data-og-selected-delivery]',
    '.og-delivery-summary',
    '.og-delivery-selected',
    '[class*="selected"][class*="delivery"]',
    '[class*="delivery"][class*="summary"]',
    '#ogDeliveryWidget',
    '.og-delivery-widget'
  ].join(',')).map(node => normalize(node.textContent)).filter(Boolean).join(' | ');
  const extractLabel = (text, label) => {
    const labels = [
      'Delivery City', 'Delivery Pincode', 'Delivery Date', 'Delivery Type', 'Delivery Slot',
      'Select Date', 'Selected Date', 'Pick Delivery Date', 'Pick Delivery Type',
      'Selected Delivery Type', 'Time Slot', 'Select Time Slot', 'Delivery Time',
      'Selected Time Slot', 'Pin Code', 'Pincode', 'Postal Code', 'Delivery Location',
      'Delivery Charge', 'Delivery Fee', 'Final Delivery Charge', 'Remote Charge'
    ];
    const escaped = label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const others = labels
      .filter(item => item !== label)
      .map(item => item.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
      .join('|');
    const match = normalize(text).match(new RegExp(`${escaped}\\s*:?\\s*(.*?)(?=\\s*(?:${others})\\s*:?|$)`, 'i'));
    return match ? normalize(match[1]) : '';
  };
  const cleanDeliveryType = value => {
    const text = normalize(value);
    if (/morning/i.test(text)) return 'Morning Delivery';
    if (/express/i.test(text)) return 'Express Delivery';
    if (/standard/i.test(text)) return 'Standard Delivery';
    if (/fixed/i.test(text)) return 'Fixed Time Delivery';
    if (/midnight/i.test(text)) return 'Midnight Delivery';
    if (/remote/i.test(text)) return 'Remote Delivery';
    if (/next/i.test(text)) return 'Next Day Delivery';
    return text;
  };
  const cleanDeliveryDate = value => {
    let text = normalize(value)
      .replace(/^Delivery Date\s*:?\s*/i, '')
      .replace(/^Select(?:ed)? Date\s*:?\s*/i, '')
      .replace(/\bDelivery Type\b.*$/i, '')
      .replace(/\bDelivery Slot\b.*$/i, '')
      .replace(/\bDelivery Charge\b.*$/i, '')
      .trim();
    if (!text || /localStorage|function|document\.|window\.|=>|\\{|\\}/i.test(text)) return '';
    const direct = text.match(/\b\d{1,2}[-/]\d{1,2}[-/]\d{2,4}\b/);
    if (direct) return direct[0];
    const relative = text.match(/\b(?:Today|Tomorrow)\b(?:[\s,]+(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun))?(?:[\s,]+\d{1,2})?(?:[\s,]+(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*)?/i);
    if (relative) return normalize(relative[0]);
    const monthDate = text.match(/\b\d{1,2}\s+(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*(?:\s*,?\s*\d{2,4})?\b/i);
    if (monthDate) return normalize(monthDate[0]);
    return text.length <= 48 ? text : '';
  };
  const cleanDeliverySlot = value => {
    const text = normalize(value)
      .replace(/^Delivery (?:Slot|Time)\s*:?\s*/i, '')
      .replace(/^Select(?:ed)? (?:Time )?Slot\s*:?\s*/i, '');
    if (!text) return '';
    const range = text.match(/\b\d{1,2}(?::\d{2})?\s*(?:AM|PM)\s*[-–]\s*\d{1,2}(?::\d{2})?\s*(?:AM|PM)\b/i);
    return normalize(range ? range[0] : text);
  };
  const selectedText = (selector, closestSelector) => {
    const selected = $(selector);
    if (!selected) return '';
    const source = selected.closest(closestSelector) || selected;
    return normalize(
      selected.value ||
      selected.dataset?.value ||
      selected.dataset?.date ||
      selected.dataset?.type ||
      selected.dataset?.slot ||
      source.dataset?.value ||
      source.textContent ||
      ''
    );
  };
  const storedDelivery = () => {
    try {
      const value = JSON.parse(localStorage.getItem('og_global_delivery_state_v1') || '{}');
      const updatedAt = Number(value.updatedAt || 0);
      if (updatedAt && Date.now() - updatedAt > 3600000) return {};
      return value && typeof value === 'object' ? value : {};
    } catch (error) {
      return {};
    }
  };
  const deliveryProperties = (form, suppliedFormProperties = null) => {
    const formProperties = suppliedFormProperties || readFormProperties(form);
    let cachedSummary = '';
    const getSummary = () => {
      if (!cachedSummary) cachedSummary = summaryText();
      return cachedSummary;
    };
    const saved = storedDelivery();
    const properties = {};
    const locationText = readValue([
      '[name="properties[Delivery Pincode]"]', '[name="properties[Pincode]"]',
      '[name="properties[Pin Code]"]', '[data-og-property-name="Delivery Pincode"]',
      '#ogLocationInput', '[data-og-location-input]', '.og-location-input',
      '.og-delivery-location input', 'input[placeholder*="pincode" i]'
    ]);
    const directLocationSource = `${formProperties['Delivery Pincode'] || ''} ${locationText} ${saved.pincode || ''}`;
    let pinMatch = directLocationSource.match(/\b\d{6}\b/);
    if (!pinMatch) {
      const summary = getSummary();
      pinMatch = `${extractLabel(summary, 'Delivery Pincode')} ${extractLabel(summary, 'Pincode')}`.match(/\b\d{6}\b/);
    }
    if (pinMatch) properties['Delivery Pincode'] = pinMatch[0];
    let city = formProperties['Delivery City'] || readValue([
      '[name="properties[Delivery City]"]', '[data-og-property-name="Delivery City"]', '[data-og-delivery-city]'
    ]) || extractLabel(getSummary(), 'Delivery City') || saved.city || '';
    if (!city && locationText) {
      city = normalize(locationText)
        .replace(/\b\d{6}\b/g, '')
        .replace(/\bIND\b/gi, '')
        .replace(/[,|\s-]+/g, ' ')
        .trim();
    }
    if (city) properties['Delivery City'] = normalize(city).replace(/\b\d{6}\b/g, '').replace(/^[,|\s-]+|[,|\s-]+$/g, '');
    const dateRaw = formProperties['Delivery Date'] || formProperties['Select Date'] || formProperties['Selected Date'] ||
      readValue([
        '[name="properties[Delivery Date]"]', '[name="properties[Select Date]"]',
        '[name="properties[Selected Date]"]', '[name="properties[Pick Delivery Date]"]',
        '[data-og-property-name="Delivery Date"]', '[data-og-delivery-date]'
      ]) || extractLabel(getSummary(), 'Delivery Date') || extractLabel(getSummary(), 'Select Date') ||
      selectedText(
        '.og-date-card.is-selected, .og-date-card.selected, .og-delivery-date .is-selected, .og-delivery-date [aria-pressed="true"], .og-delivery-date [aria-selected="true"], [class*="date"] input:checked',
        'label, .og-date-card, [class*="date"]'
      ) || saved.deliveryDate || '';
    const date = cleanDeliveryDate(dateRaw);
    if (date) properties['Delivery Date'] = date;
    const typeRaw = formProperties['Delivery Type'] || formProperties['Pick Delivery Type'] || formProperties['Selected Delivery Type'] ||
      readValue([
        '[name="properties[Delivery Type]"]', '[name="properties[Pick Delivery Type]"]',
        '[name="properties[Selected Delivery Type]"]', '[data-og-property-name="Delivery Type"]',
        '[data-og-delivery-type]'
      ]) || extractLabel(getSummary(), 'Delivery Type') ||
      selectedText(
        '.og-delivery_type-slot-grid input:checked, .og-delivery-type-slot-grid input:checked, .og-slot-card__radio:checked, input[name*="delivery_type" i]:checked, input[name*="delivery-type" i]:checked, [data-og-delivery-option].is-selected',
        'label, .og-slot-card, .delivery-option, [data-og-delivery-option], [class*="delivery"]'
      ) || saved.deliveryType || '';
    const deliveryType = cleanDeliveryType(typeRaw);
    if (deliveryType) properties['Delivery Type'] = deliveryType;
    const slotRaw = formProperties['Delivery Slot'] || formProperties['Time Slot'] || formProperties['Delivery Time'] ||
      readValue([
        '[name="properties[Delivery Slot]"]', '[name="properties[Time Slot]"]',
        '[name="properties[Delivery Time]"]', '[name="properties[Select Time Slot]"]',
        '[data-og-property-name="Delivery Slot"]', '[data-og-delivery-slot]'
      ]) || extractLabel(getSummary(), 'Delivery Slot') || extractLabel(getSummary(), 'Time Slot') ||
      selectedText(
        '#ogSlotOptions input:checked, .og-slot-options input:checked, .og-delivery-slot input:checked, input[name*="delivery_slot" i]:checked, input[name*="delivery-slot" i]:checked, [data-og-delivery-slot].is-selected',
        'label, .og-slot-card, .delivery-slot, [class*="slot"]'
      ) || saved.deliverySlot || '';
    const slot = cleanDeliverySlot(slotRaw);
    if (slot) properties['Delivery Slot'] = slot;
    return properties;
  };
  const validateDelivery = form => {
    if (!config.requireDeliverySelection || config.currentProductIsCourier) return true;
    const props = deliveryProperties(form);
    const required = ['Delivery Pincode', 'Delivery Date', 'Delivery Type', 'Delivery Slot'];
    const missing = required.filter(key => !props[key]);
    if (!missing.length) return true;
    const area = $('#og-delivery-widget, .og-delivery-widget, #ogDeliveryWidget, [data-og-delivery-widget]');
    area?.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
    window.alert(`Please select ${missing.map(key => key.replace('Delivery ', '').toLowerCase()).join(', ')} first.`);
    return false;
  };
  const validateForm = form => {
    if (!form || !getVariantId(form)) {
      window.alert('Please select a product option first.');
      return false;
    }
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      form.reportValidity?.();
      return false;
    }
    return validateDelivery(form);
  };
  const feeFromType = type => {
    const value = lower(type);
    for (const [needle, amount] of Object.entries(config.deliveryFeeFallbackByType || {})) {
      if (value.includes(lower(needle))) return Number(amount) || 0;
    }
    return 0;
  };
  const deliveryFeeAmount = (form, props, suppliedFormProperties = null) => {
    const formProps = suppliedFormProperties || readFormProperties(form);
    const directCandidates = [
      formProps['_og_delivery_fee_amount'],
      formProps['Delivery Charge'],
      formProps['Delivery Fee'],
      readValue([
        '[name="properties[_og_delivery_fee_amount]"]',
        '[name="properties[Delivery Charge]"]',
        '[name="properties[Delivery Fee]"]',
        '[data-og-delivery-fee]',
        '[data-delivery-fee]'
      ])
    ];
    for (const candidate of directCandidates) {
      const match = String(candidate || '').replace(/,/g, '').match(/(?:₹|Rs\.?|INR)?\s*(\d+(?:\.\d+)?)/i);
      if (match) return Math.max(0, Math.round(Number(match[1]) || 0));
    }
    const summary = summaryText();
    for (const candidate of [extractLabel(summary, 'Delivery Charge'), extractLabel(summary, 'Delivery Fee')]) {
      const match = String(candidate || '').replace(/,/g, '').match(/(?:₹|Rs\.?|INR)?\s*(\d+(?:\.\d+)?)/i);
      if (match) return Math.max(0, Math.round(Number(match[1]) || 0));
    }
    return feeFromType(props['Delivery Type']);
  };
  const availableVariant = product => {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    return variants.find(variant => variant.available !== false) || variants[0] || null;
  };
  const cardImageUrl = value => {
    const source = String(value || '');
    if (!source) return '';
    try {
      const url = new URL(source, window.location.origin);
      if (url.hostname.endsWith('shopify.com') || url.hostname.endsWith('shopifycdn.com')) {
        url.searchParams.set('width', '480');
      }
      return url.href;
    } catch (error) {
      return source;
    }
  };
  const mapProduct = product => {
    const variant = availableVariant(product);
    const image = cardImageUrl(product.images?.[0]?.src || product.image?.src || product.featured_image || '');
    if (!variant?.id) return null;
    return {
      id: Number(variant.id),
      handle: String(product.handle || ''),
      title: normalize(product.title),
      price: priceNumber(variant.price ?? product.price ?? 0),
      image,
      available: variant.available !== false
    };
  };
  const fetchCategory = async category => {
    const handle = normalize(category.handle);
    if (!handle) return [];
    const limit = 50;
    const response = await fetch(api(`/collections/${encodeURIComponent(handle)}/products.json?limit=${limit}`), {
      headers: { Accept: 'application/json' },
      cache: 'default'
    });
    if (!response.ok) throw new Error(`${category.title} add-ons could not be loaded.`);
    const data = await response.json();
    return (data.products || [])
      .map(mapProduct)
      .filter(Boolean)
      .slice(0, limit);
  };
  const saveSelection = () => {
    try {
      const values = Array.from(state.selected.values());
      sessionStorage.setItem(sharedSelectionKey, JSON.stringify(values));
      localStorage.setItem(sharedSelectionPersistentKey, JSON.stringify(values));
      // Legacy ID-only key kept for backward compatibility.
      localStorage.setItem(selectionKey, JSON.stringify(Array.from(state.selected.keys())));
    } catch (error) {
      console.warn('[OG Add-ons] Selection could not be saved:', error);
    }
  };
  const queueSelectionSave = () => {
    window.clearTimeout(state.selectionSaveTimer);
    if (state.selectionSaveIdle && 'cancelIdleCallback' in window) {
      window.cancelIdleCallback(state.selectionSaveIdle);
      state.selectionSaveIdle = 0;
    }
    state.selectionSaveTimer = window.setTimeout(() => {
      state.selectionSaveTimer = 0;
      if ('requestIdleCallback' in window) {
        state.selectionSaveIdle = window.requestIdleCallback(() => {
          state.selectionSaveIdle = 0;
          saveSelection();
        }, { timeout: 1000 });
      } else {
        saveSelection();
      }
    }, 180);
  };
  const restoreSelection = () => {
    try {
      const allProducts = Array.from(state.productsByCategory.values()).flat();
      const byId = new Map(allProducts.map(product => [Number(product.id), product]));
      let values = null;
      const sessionRaw = sessionStorage.getItem(sharedSelectionKey);
      const persistentRaw = localStorage.getItem(sharedSelectionPersistentKey);
      if (sessionRaw !== null) values = JSON.parse(sessionRaw);
      if ((!Array.isArray(values) || !values.length) && persistentRaw !== null) values = JSON.parse(persistentRaw);
      if (!Array.isArray(values) || !values.length) {
        const legacyIds = JSON.parse(localStorage.getItem(selectionKey) || '[]');
        values = (Array.isArray(legacyIds) ? legacyIds : []).map(id => byId.get(Number(id))).filter(Boolean);
      }
      state.selected.clear();
      (Array.isArray(values) ? values : []).slice(0, config.maxSelectable).forEach(saved => {
        if (!saved || !Number(saved.id)) return;
        const live = byId.get(Number(saved.id));
        const product = live ? { ...saved, ...live } : saved;
        state.selected.set(Number(product.id), product);
      });
      // Keep saved add-ons available on every eligible product page, even when
      // the current collection response does not contain an older selection.
      const firstKey = config.categories?.[0]?.key;
      if (firstKey) {
        const current = state.productsByCategory.get(firstKey) || [];
        const currentIds = new Set(current.map(product => Number(product.id)));
        const missing = Array.from(state.selected.values()).filter(product => !currentIds.has(Number(product.id)));
        if (missing.length) state.productsByCategory.set(firstKey, [...missing, ...current]);
      }
      // Re-save migrated/normalized data so future pages do not depend on a fetch race.
      if (state.selected.size) saveSelection();
    } catch (error) { console.warn('[OG Add-ons] Unable to restore saved add-ons:', error); }
  };
  const cardMarkup = (product, index, eagerSection) => {
    const selected = state.selected.has(product.id);
    const eager = eagerSection && index < 9;
    const imageMarkup = product.image
      ? `<img src="${eager ? escapeHtml(product.image) : transparentPixel}"${eager ? '' : ` data-og-src="${escapeHtml(product.image)}"`} alt="${escapeHtml(product.title)}" loading="${eager ? 'eager' : 'lazy'}" fetchpriority="${eager && index < 3 ? 'high' : 'low'}" decoding="async" width="220" height="220">`
      : '<span class="og-addon__image-placeholder">🎁</span>';
    return `
      <article class="og-addon__card${selected ? ' is-selected' : ''}" data-variant-id="${product.id}">
      <button class="og-addon__card-button" type="button" aria-pressed="${selected ? 'true' : 'false'}" aria-label="Add ${escapeHtml(product.title)}">
        <span class="og-addon__image">
          ${imageMarkup}
          <span class="og-addon__check" aria-hidden="true">✓</span>
        </span>
        <span class="og-addon__title">${escapeHtml(product.title)}</span>
        <strong class="og-addon__price">${money(product.price)}</strong>
        <span class="og-addon__select">${selected ? '✓ Added' : '+ Add'}</span>
      </button>
      </article>
    `;
  };
  const indexRenderedCards = () => {
    const deferredImages = [];
    $$('.og-addon__card', els.sections).forEach(card => {
      const variantId = Number(card.dataset.variantId || 0);
      if (!variantId) return;
      card._ogButton = card.firstElementChild;
      card._ogLabel = card._ogButton?.lastElementChild || null;
      const cards = state.cardsByVariant.get(variantId) || [];
      cards.push(card);
      state.cardsByVariant.set(variantId, cards);
      const image = card._ogButton?.firstElementChild?.firstElementChild;
      if (image?.dataset?.ogSrc) deferredImages.push(image);
    });
    return deferredImages;
  };
  const loadDeferredImage = image => {
    const source = image?.dataset?.ogSrc;
    if (!source) return;
    image.src = source;
    image.removeAttribute('data-og-src');
  };
  const observeDeferredImages = images => {
    state.imageObserver?.disconnect();
    state.imageObserver = null;
    if (!images.length) return;
    if (!('IntersectionObserver' in window)) {
      images.forEach(loadDeferredImage);
      return;
    }
    state.imageObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        loadDeferredImage(entry.target);
        state.imageObserver?.unobserve(entry.target);
      });
    }, {
      root: els.body,
      rootMargin: '700px 0px',
      threshold: 0.01
    });
    images.forEach(image => state.imageObserver.observe(image));
  };
  const setActiveCategory = key => {
    if (!key || state.activeCategory === key) return;
    state.activeCategory = key;
    $$('[data-og-tab-key]', popup).forEach(tab => {
      const active = tab.dataset.ogTabKey === key;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  };
  const syncTabWithScroll = () => {
    if (!els.body) return;
    const sections = state.renderedSections;
    if (!sections.length) return;
    const marker = els.body.scrollTop + 150;
    let active = sections[0].dataset.ogCategorySection;
    sections.forEach(section => {
      if (section.offsetTop <= marker) active = section.dataset.ogCategorySection;
    });
    setActiveCategory(active);
  };
  const requestTabSync = () => {
    if (state.scrollRaf) return;
    state.scrollRaf = window.requestAnimationFrame(() => {
      state.scrollRaf = 0;
      syncTabWithScroll();
    });
  };
  const render = () => {
    const tabsFragment = document.createDocumentFragment();
    const sectionsFragment = document.createDocumentFragment();
    state.productByVariant.clear();
    state.cardsByVariant.clear();
    state.renderedSections = [];
    state.activeCategory = '';
    let totalProducts = 0;
    (config.categories || []).forEach((category, categoryIndex) => {
      const products = (state.productsByCategory.get(category.key) || []).filter(product => {
        return product.id !== state.activeVariantId && product.handle !== state.activeProductHandle;
      });
      if (!products.length) return;
      totalProducts += products.length;
      products.forEach(product => state.productByVariant.set(product.id, product));
      const tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'og-addon__tab';
      tab.dataset.ogTabKey = category.key;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', 'false');
      tab.textContent = category.title;
      tab.addEventListener('click', () => {
        const targetSection = popup.querySelector(`[data-og-category-section="${category.key}"]`);
        if (!targetSection || !els.body) return;
        setActiveCategory(category.key);
        els.body.scrollTop = Math.max(0, targetSection.offsetTop - 8);
      });
      tabsFragment.appendChild(tab);
      const section = document.createElement('section');
      section.className = 'og-addon__section';
      section.dataset.ogCategorySection = category.key;
      section.innerHTML = `
        <div class="og-addon__section-head">
          <h3>${escapeHtml(category.title)}</h3>
          <span>${products.length} options</span>
        </div>
        <div class="og-addon__grid">${products.map((product, index) => cardMarkup(product, index, categoryIndex === 0)).join('')}</div>
      `;
      sectionsFragment.appendChild(section);
    });
    els.tabs.replaceChildren(tabsFragment);
    els.sections.replaceChildren(sectionsFragment);
    state.renderedSections = $$('[data-og-category-section]', els.sections);
    observeDeferredImages(indexRenderedCards());
    state.renderedVariantId = state.activeVariantId;
    state.renderedProductHandle = state.activeProductHandle;
    els.tabs.hidden = totalProducts === 0;
    els.empty.hidden = totalProducts !== 0;
    updateFooter();
    setActiveCategory(els.tabs.querySelector('[data-og-tab-key]')?.dataset.ogTabKey || '');
  };
  const loadProducts = () => {
    if (state.loaded) return Promise.resolve();
    if (state.loadingPromise) return state.loadingPromise;
    show(els.loading);
    hide(els.empty);
    setStatus('');
    state.loadingPromise = (async () => {
      try {
        const results = await Promise.allSettled((config.categories || []).map(fetchCategory));
        results.forEach((result, index) => {
          const category = config.categories[index];
          state.productsByCategory.set(category.key, result.status === 'fulfilled' ? result.value : []);
          if (result.status === 'rejected') console.warn('[OG Add-ons]', result.reason);
        });
        state.loaded = true;
        restoreSelection();
      } catch (error) {
        setStatus(error.message || 'Add-ons could not be loaded. You can still continue.', 'error');
        show(els.empty);
      } finally {
        state.loadingPromise = null;
        hide(els.loading);
      }
    })();
    return state.loadingPromise;
  };
  const paintCard = (card, selected) => {
    const button = card._ogButton || $('.og-addon__card-button', card);
    const label = card._ogLabel || $('.og-addon__select', card);
    card.classList.toggle('is-selected', selected);
    button?.setAttribute('aria-pressed', selected ? 'true' : 'false');
    if (label) label.textContent = selected ? '✓ Added' : '+ Add';
  };
  const toggleProduct = (product, sourceCard) => {
    if (state.selected.has(product.id)) {
      state.selected.delete(product.id);
    } else {
      if (state.selected.size >= Number(config.maxSelectable || 50)) {
        setStatus(`Maximum ${config.maxSelectable} add-ons can be selected.`, 'error');
        return;
      }
      state.selected.set(product.id, product);
    }
    const selected = state.selected.has(product.id);
    const cards = state.cardsByVariant.get(product.id) || (sourceCard ? [sourceCard] : []);
    cards.forEach(card => paintCard(card, selected));
    queueSelectionSave();
    renderSummary();
    setStatus('');
    updateFooter();
  };
  const updateFooter = () => {
    if (!els.continueBtn || state.adding) return;
    const count = state.selected.size;
    els.continueBtn.textContent = count
      ? `CONTINUE WITH ${count} ADD-ON${count === 1 ? '' : 'S'}`
      : 'CONTINUE';
    if (els.skip) els.skip.hidden = count > 0;
  };
  const openPopup = async (form, editOnly = false, initialStep = 'addons') => {
    if (state.adding || !popup.hidden || !form) return;
    state.editOnly = editOnly;
    setFinalLabel();
    state.activeForm = form;
    state.activeVariantId = getVariantId(form);
    state.activeProductHandle = getCurrentHandle();
    state.activeCategory = '';
    resetSenderStep();
    setStatus('');
    void prefetchCart().catch(() => {});
    state.bodyScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${state.bodyScrollY}px`;
    document.body.style.width = '100%';
    document.body.classList.add('og-addon-lock');
    if (popup.parentElement !== document.body) document.body.appendChild(popup);
    window.clearTimeout(state.popupHideTimer);
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    popup.classList.remove('is-open');
    void popup.offsetWidth;
    window.requestAnimationFrame(() => popup.classList.add('is-open'));
    els.body.scrollTop = 0;
    await loadProducts();
    if (
      state.loaded &&
      (state.renderedVariantId !== state.activeVariantId || state.renderedProductHandle !== state.activeProductHandle)
    ) render();
    renderSummary();
    if (editOnly && initialStep === 'details') showSenderStep();

    requestAnimationFrame(() => els.dialog?.focus());
  };
  const hidePopup = () => new Promise(resolve => {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    window.clearTimeout(state.popupHideTimer);
    state.popupHideTimer = window.setTimeout(() => {
      popup.hidden = true;
      document.body.classList.remove('og-addon-lock');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('width');
      window.scrollTo(0, state.bodyScrollY);
      resolve();
    }, 320);
  });
  /* FAST proceed close:
     Continue/Skip should not wait 320ms for the sheet animation before /checkout.
     Remove the sheet synchronously for a faster hand-off. */
  const hidePopupNow = () => {
    window.clearTimeout(state.popupHideTimer);
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    popup.hidden = true;
    document.body.classList.remove('og-addon-lock');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('width');
    /* Do not use smooth scrolling here; restore position immediately. */
    window.scrollTo(0, state.bodyScrollY);
  };
  const isFeeItem = item => {
    return Number(item.product_id) === Number(config.deliveryFeeProductId) || lower(item.properties?._og_delivery_fee) === 'true';
  };
  const isAddonItem = item => lower(item.properties?._addon_item) === 'true';
  const parentType = () => config.currentProductIsCourier ? 'courier' : 'express';
  const feeForCartItem = item => {
    const direct = priceNumber(item.properties?._og_delivery_fee_amount || 0);
    if (Number.isFinite(direct) && direct > 0) return direct;
    return feeFromType(item.properties?.['Delivery Type'] || '');
  };
  const cartItemParentType = item => lower(
    item.properties?._og_parent_type ||
    item.properties?._addon_parent_type ||
    item.properties?.['_Product Delivery Mode'] ||
    ''
  );
  const addConfigurationToCart = async () => {
    const form = state.activeForm;
    const variantId = getVariantId(form) || state.activeVariantId;
    if (!variantId) throw new Error('Main product variant was not found.');
    const type = parentType();
    const quantity = getQuantity(form);
    const plan = getSellingPlan(form);
    const formProperties = readFormProperties(form);
    const delivery = type === 'express' ? deliveryProperties(form, formProperties) : {};
    const fee = type === 'express' ? deliveryFeeAmount(form, delivery, formProperties) : 0;
    const group = `og_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    const properties = {
      ...formProperties,
      ...delivery,
      _addon_group_id: group,
      _has_addons: state.selected.size ? 'true' : 'false',
      _og_parent_type: type,
      _addon_parent_type: type,
      '_Product Delivery Mode': type
    };
    if (type === 'courier') {
      ['Delivery City', 'Delivery Pincode', 'Delivery Date', 'Delivery Type', 'Delivery Slot', 'Delivery Charge', 'Delivery Fee']
        .forEach(key => delete properties[key]);
    } else {
      [
        'Select Date', 'Selected Date', 'Pick Delivery Date', 'Pick Delivery Type',
        'Selected Delivery Type', 'Time Slot', 'Select Time Slot', 'Delivery Time',
        'Selected Time Slot', 'Pin Code', 'Pincode', 'Postal Code',
        'Delivery Location', 'Selected Location'
      ].forEach(key => delete properties[key]);
      if (fee > 0) properties._og_delivery_fee_amount = String(fee);
    }
    const parentItem = { id: variantId, quantity, properties };
    if (plan) parentItem.selling_plan = plan;
    const addonItems = Array.from(state.selected.values())
      .filter(product => product.id !== variantId)
      .map(product => ({
        id: product.id,
        quantity,
        properties: {
          _addon_item: 'true',
          _addon_group_id: group,
          _addon_for_product: normalize($('.product__title, [data-product-title], h1')?.textContent || document.title),
          _addon_parent_variant_id: String(variantId),
          _addon_parent_key: `pending_${group}`,
          _addon_parent_type: type
        }
      }));
    /*
       IMPORTANT:
       Always read the cart fresh at final submit time.
       The popup may have been open for a while or the browser may have returned
       from checkout using BFCache, so a prefetched snapshot must not decide
       which old lines are removed.
    */
    const cart = await fetchCart();
    clearCartSnapshot();
    const cartItems = cart.items || [];
    /*
       Same variant = one latest configuration only.
       Every old parent line of this exact variant is replaced, together with
       add-ons linked to that old parent/group.
    */
    const oldParents = cartItems.filter(item => (
      Number(item.variant_id) === variantId &&
      !isAddonItem(item) &&
      !isFeeItem(item)
    ));
    const oldParentKeys = new Set(
      oldParents.map(item => String(item.key || '')).filter(Boolean)
    );
    const oldGroups = new Set(
      oldParents
        .map(item => normalize(item.properties?._addon_group_id))
        .filter(Boolean)
    );
    const updates = {};
    const remainingItems = [];
    cartItems.forEach(item => {
      const itemKey = String(item.key || '');
      const itemGroup = normalize(item.properties?._addon_group_id);
      const itemParentKey = normalize(item.properties?._addon_parent_key);
      const itemParentVariant = Number(item.properties?._addon_parent_variant_id || 0);
      const removeParent = oldParentKeys.has(itemKey);
      const removeAddon = isAddonItem(item) && (
        oldGroups.has(itemGroup) ||
        oldParentKeys.has(itemParentKey) ||
        itemParentVariant === variantId
      );
      /*
         Delivery fee is intentionally maintained as ONE cart-level line.
         All old delivery-fee lines are removed first; the correct latest/max
         fee is added again below.
      */
      const removeItem = isFeeItem(item) || removeParent || removeAddon;
      if (removeItem) {
        if (itemKey) updates[itemKey] = 0;
      } else {
        remainingItems.push(item);
      }
    });
    /*
       Preserve the existing cart-level rule:
       when other express products remain in cart, keep only the maximum
       delivery fee required by any remaining/current express configuration.
    */
    const otherMaximumFee = Math.max(
      0,
      ...remainingItems
        .filter(item => !isAddonItem(item) && cartItemParentType(item).includes('express'))
        .map(feeForCartItem)
    );
    const expectedFee = Math.max(
      otherMaximumFee,
      type === 'express' ? Number(fee || 0) : 0
    );
    const feeVariantId = Number(
      config.deliveryFeeVariantByAmount?.[String(Math.round(expectedFee))] || 0
    );
    if (expectedFee > 0 && !feeVariantId) {
      throw new Error(`Delivery fee configuration is missing for ₹${Math.round(expectedFee)}.`);
    }
    const itemsToAdd = [parentItem, ...addonItems];
    if (expectedFee > 0) {
      itemsToAdd.push({
        id: feeVariantId,
        quantity: 1,
        properties: {
          _og_delivery_fee: 'true',
          _og_delivery_fee_amount: String(Math.round(expectedFee)),
          _og_delivery_fee_group: group
        }
      });
    }
    /*
       CRITICAL FIX:
       Never remove old lines and add new lines in parallel.
       Step 1 must finish first, then Step 2 starts.
    */
    if (Object.keys(updates).length) {
      await postJson(api('/cart/update.js'), { updates });
    }
    await postJson(api('/cart/add.js'), { items: itemsToAdd });
    clearCartSnapshot();
    /*
       FINAL SAFETY PASS:
       Verify that this variant has only the newly-created parent group,
       remove any stale same-variant parent/add-on that survived another
       script/race, and guarantee only one delivery-fee line remains.
    */
    let finalCart = await fetchCart();
    const finalUpdates = {};
    const finalItems = finalCart.items || [];
    const currentParent = finalItems.find(item => (
      Number(item.variant_id) === variantId &&
      !isAddonItem(item) &&
      !isFeeItem(item) &&
      normalize(item.properties?._addon_group_id) === group
    ));
    if (!currentParent) {
      throw new Error('Latest product configuration could not be verified in cart.');
    }
    const currentParentKey = String(currentParent.key || '');
    finalItems.forEach(item => {
      const itemKey = String(item.key || '');
      if (!itemKey) return;
      const itemGroup = normalize(item.properties?._addon_group_id);
      const itemParentKey = normalize(item.properties?._addon_parent_key);
      const itemParentVariant = Number(item.properties?._addon_parent_variant_id || 0);
      const sameVariantParent = (
        Number(item.variant_id) === variantId &&
        !isAddonItem(item) &&
        !isFeeItem(item)
      );
      const staleParent = (
        sameVariantParent &&
        normalize(item.properties?._addon_group_id) !== group
      );
      const staleAddon = (
        isAddonItem(item) &&
        itemGroup !== group &&
        (
          itemParentVariant === variantId ||
          (currentParentKey && itemParentKey === currentParentKey)
        )
      );
      if (staleParent || staleAddon) {
        finalUpdates[itemKey] = 0;
      }
    });
    /*
       Delivery fee de-duplication.
       Keep exactly one matching current fee line (quantity 1).
       All other delivery-fee lines are removed.
    */
    const feeItems = finalItems.filter(isFeeItem);
    if (expectedFee > 0) {
      let keepFee = feeItems.find(item => (
        Number(item.variant_id) === feeVariantId &&
        normalize(item.properties?._og_delivery_fee_group) === group
      ));
      if (!keepFee) {
        keepFee = feeItems.find(item => Number(item.variant_id) === feeVariantId);
      }
      if (!keepFee) {
        throw new Error('Latest delivery fee could not be verified in cart.');
      }
      feeItems.forEach(item => {
        const itemKey = String(item.key || '');
        if (!itemKey) return;
        if (itemKey === String(keepFee.key || '')) {
          if (Number(item.quantity || 0) !== 1) {
            finalUpdates[itemKey] = 1;
          }
        } else {
          finalUpdates[itemKey] = 0;
        }
      });
    } else {
      feeItems.forEach(item => {
        const itemKey = String(item.key || '');
        if (itemKey) finalUpdates[itemKey] = 0;
      });
    }
    if (Object.keys(finalUpdates).length) {
      await postJson(api('/cart/update.js'), { updates: finalUpdates });
      finalCart = await fetchCart();
    }
    clearCartSnapshot();
    return finalCart;
  };
  /* --------------------------------------------------------------------------
     FINAL PAGE FLOW
     Continue / Skip / Close / Overlay / Escape -> same successful cart write
     -> Shopify /checkout when OG_REDIRECT_TO_CHECKOUT = true
     -> /cart when OG_REDIRECT_TO_CHECKOUT = false
     No account/login page, pending marker, SDK listener, or OTP wait.
  -------------------------------------------------------------------------- */
  const submitFinal = async () => {
    if (state.adding) return;
    saveCompletedSummary();
    if (state.editOnly) {
      closeOccasionMenu();
      closeGiftMessageModal();
      hidePopupNow();
      state.editOnly = false;
      setFinalLabel();
      summaryNode?.querySelector('[data-og-summary-change]')?.focus({ preventScroll: true });
      return;
    }
    state.adding = true;
    setStatus('');
    closeOccasionMenu();
    closeGiftMessageModal();
    const controls = [els.detailsContinue, els.detailsSkip, els.detailsClose].filter(Boolean);
    controls.forEach(control => {
      control.setAttribute('aria-disabled', 'true');
      control.setAttribute('aria-busy', 'true');
    });
    const label = $('.og-addon__details-continue-text > span:first-child', popup);
    const suffix = $('.og-addon__checkout-label', popup);
    const finalCta = els.detailsContinue;
    let stageTimer = 0;
    if (finalCta) finalCta.classList.add('is-processing');
    if (label) label.textContent = 'ADDING PRODUCTS…';
    if (suffix) suffix.textContent = '';
    stageTimer = window.setTimeout(() => {
      if (!state.adding || !label) return;
      label.textContent = 'SAVING MESSAGE…';
    }, 450);
    const processingTimer = window.setTimeout(() => {
      if (!state.adding || !label) return;
      label.textContent = 'PROCESSING…';
    }, 950);
    try {
      await addConfigurationToCart();
      window.clearTimeout(stageTimer);
      window.clearTimeout(processingTimer);
      if (label) label.textContent = 'PROCESSING…';
      window.location.replace(OG_REDIRECT_TO_CHECKOUT ? `${root.replace(/\/$/, '')}/checkout?_og_shopify=${Date.now()}` : api('/cart'));
    } catch (error) {
      window.clearTimeout(stageTimer);
      window.clearTimeout(processingTimer);
      console.error('[OG Add-ons] Final checkout failed:', error);
      setStatus(error.message || 'Unable to continue. Please try again.', 'error');
      state.adding = false;
      releasePurchaseButton();
      if (popup.hidden) window.alert(error.message || 'Unable to continue. Please try again.');
      controls.forEach(control => {
        control.removeAttribute('aria-disabled');
        control.removeAttribute('aria-busy');
      });
      if (finalCta) finalCta.classList.remove('is-processing');
      if (label) label.textContent = 'CONTINUE';
      if (suffix) suffix.textContent = ' TO CHECKOUT';
    }
  };
  const isBuyButton = button => {
    if (!button) return false;
    const text = lower(button.textContent || button.value);
    return (
      button.matches(config.buyButtonSelector) ||
      text.includes('send this gift now') ||
      text.includes('buy now') ||
      text.includes('add to cart') ||
      text.includes('send gift') ||
      text.includes('send this gift')
    );
  };
  const formFromButton = button => button.closest(config.productFormSelector) || button.closest('form') || $(config.productFormSelector);
  document.addEventListener('click', event => {
    /* Nothing inside the add-on popup may be interpreted as the main product
       Add-to-Cart/Buy button. */
    if (popup.contains(event.target) || event.target.closest('#OgGiftSummary')) return;
    const button = event.target.closest(config.buyButtonSelector);
    if (!button || !isBuyButton(button)) return;
    const form = formFromButton(button);
    if (!form?.matches(config.productFormSelector)) return;
    if (!validateForm(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    void startPurchase(form, button);
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form?.matches(config.productFormSelector)) return;
    if (event.submitter && !isBuyButton(event.submitter)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (validateForm(form)) void startPurchase(form, event.submitter);
  }, true);
  /* FIRST STEP -> optional sender/message panel. SECOND STEP -> checkout. */
  const finalControlFromEvent = event => {
    if (popup.hidden || state.stage !== 'details') return null;
    const target = event.target;
    if (!(target instanceof Element)) return null;
    return target.closest('[data-og-final-continue],[data-og-final-skip],[data-og-details-close]');
  };
  window.addEventListener('click', event => {
    const control = finalControlFromEvent(event);
    if (!control) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    const includeDetails = !control.matches('[data-og-final-skip]');
    applySenderProperties(includeDetails);
    void submitFinal();
  }, true);
  const finalControlFromTarget = target => {
    if (popup.hidden || state.stage !== 'details' || !(target instanceof Element)) return null;
    return target.closest('[data-og-details-continue],[data-og-details-skip],[data-og-details-close]');
  };
  const runFinalControl = (control, event) => {
    if (!control || state.adding) return;
    event?.preventDefault();
    event?.stopPropagation();
    event?.stopImmediatePropagation();
    const includeDetails = !control.matches('[data-og-details-skip]');
    applySenderProperties(includeDetails);
    void submitFinal();
  };
  popup.addEventListener('click', event => {
    runFinalControl(finalControlFromTarget(event.target), event);
  }, true);
  popup.addEventListener('keydown', event => {
    if (!['Enter', ' '].includes(event.key)) return;
    const control = finalControlFromTarget(event.target);
    if (!control) return;
    runFinalControl(control, event);
  }, true);
  popup.addEventListener('click', event => {
    const close = event.target.closest('[data-og-addon-close]');
    if (!close) return;
    event.preventDefault();
    event.stopPropagation();
    if (state.stage === 'addons') {
      showSenderStep();
      return;
    }
    applySenderProperties(true);
    void submitFinal();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || popup.hidden || state.adding) return;
    event.preventDefault();
    event.stopPropagation();
    if (!els.messageModal?.hidden) {
      closeGiftMessageModal();
      return;
    }
    if (state.stage === 'addons') {
      showSenderStep();
      return;
    }
    applySenderProperties(true);
    void submitFinal();
  });
  els.continueBtn?.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    showSenderStep();
  });
  els.skip?.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    showSenderStep();
  });
  els.detailsBack?.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    showAddonStep();
  });
  /* Add-on select/unselect = LOCAL UI ONLY.
     Selection alone never writes the cart and never redirects. */
  els.sections?.addEventListener('click', event => {
    const button = event.target.closest('.og-addon__card-button');
    if (!button || !els.sections.contains(button)) return;
    event.preventDefault();
    event.stopPropagation();
    const card = button.closest('.og-addon__card');
    const product = state.productByVariant.get(Number(card?.dataset.variantId || 0));
    if (card && product) toggleProduct(product, card);
  });
  els.body?.addEventListener('scroll', requestTabSync, { passive: true });
  /* Compact summary only: the existing delivery widget and popup markup stay intact. */
  const summaryKey = 'og_summary_completed_shared_v2';
  let summaryNode = null;
  const summaryIcon = name => {
    const paths = {phone:'<path d="M7 3H4a1 1 0 0 0-1 1c0 10 7 17 17 17a1 1 0 0 0 1-1v-3l-5-2-2 2a15 15 0 0 1-7-7l2-2-2-5Z"/>',user:'<circle cx="12" cy="7" r="3"/><path d="M5 21v-3a7 7 0 0 1 14 0v3"/>',gift:'<path d="M3 8h18v4H3zM5 12v9h14v-9M12 8v13"/><path d="M12 8H8a3 3 0 1 1 3-3l1 3Zm0 0h4a3 3 0 1 0-3-3l-1 3Z"/>',message:'<path d="M4 4h16v13H9l-5 4V4Z"/><path d="M8 8h8M8 12h5"/>'};
    return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">${paths[name]}</svg>`;
  };
  const setFinalLabel = () => {
    const label = $('.og-addon__details-continue-text > span:first-child', popup);
    const suffix = $('.og-addon__checkout-label', popup);
    if (label) label.textContent = state.editOnly ? 'SAVE CHANGES' : 'CONTINUE';
    if (suffix) suffix.textContent = state.editOnly ? '' : ' TO CHECKOUT';
  };
  const mountSummary = () => {
    const widget = document.getElementById('og-delivery-widget');
    if (!widget) return null;
    if (!summaryNode) {
      summaryNode = document.createElement('section');
      summaryNode.id = 'OgGiftSummary';
      summaryNode.className = 'og-gift-summary';
      summaryNode.setAttribute('aria-label', 'Selected add-ons and message');
      summaryNode.addEventListener('click', event => {
        const control = event.target.closest('[data-og-summary-change]');
        if (!control) return;
        event.preventDefault();
        const form = $(config.productFormSelector);
        if (form && !state.preparing && !state.adding) void openPopup(form, true);
      });
    }
    if (widget.nextElementSibling !== summaryNode) widget.insertAdjacentElement('afterend', summaryNode);
    return summaryNode;
  };
  const renderSummary = () => {
    const node = mountSummary();
    if (!node) return;
    const products = Array.from(state.selected.values());
    const sender = readSenderSession();
    const name = normalize(sender.senderName);
    const phone = normalize(sender.senderPhone);
    const message = String(sender.giftMessage || '').trim();
    const occasion = sender.occasionChosen === true && sender.occasion !== 'All' ? normalize(sender.occasion) : '';
    const senderHasContent = hasSenderContent(sender);
    node.hidden = !(products.length || senderHasContent);
    if (node.hidden) return;
    const summaryOpen = !!node.querySelector('.og-gift-summary__combined[open]');
    const thumbs = products.slice(0, 2).map(product => product.image
      ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" width="35" height="35" loading="lazy">`
      : '').join('');
    const list = products.map(product => `<li><span>${escapeHtml(product.title)}</span><strong>${escapeHtml(money(product.price))}</strong></li>`).join('');
    const rows = [];
    if (name) rows.push(['Sender Name', name]);
    if (phone) rows.push(['Phone Number', phone]);
    if (occasion) rows.push(['Occasion', occasion]);
    if (message) rows.push(['Gift Message', message]);
    if (sender.hideName) rows.push(['Hide Sender Name', 'Yes']);
    const savedDetails = rows.length
      ? rows.map(([label, value]) => `<div class="og-gift-summary__detail-row"><dt>${label}</dt><dd>${escapeHtml(value)}</dd></div>`).join('')
      : '<div class="og-gift-summary__empty-detail">No sender or message details saved.</div>';
    const inlineParts = [];
    if (name) inlineParts.push(`<span class="og-gift-summary__inline-item">${summaryIcon('user')}<span>${escapeHtml(name)}</span></span>`);
    if (phone) inlineParts.push(`<span class="og-gift-summary__inline-item og-gift-summary__inline-phone">${summaryIcon('phone')}<span>${escapeHtml(phone)}</span></span>`);
    if (occasion) inlineParts.push(`<span class="og-gift-summary__inline-item og-gift-summary__inline-occasion">${summaryIcon('gift')}<span>${escapeHtml(occasion)}</span></span>`);
    if (message) inlineParts.push(`<span class="og-gift-summary__inline-item og-gift-summary__inline-message">${summaryIcon('message')}<span>${escapeHtml(message)}</span></span>`);
    if (!inlineParts.length) inlineParts.push(`<span class="og-gift-summary__inline-item">${summaryIcon('message')}<span>No message</span></span>`);
    node.innerHTML = `<div class="og-gift-summary__row"><details class="og-gift-summary__combined"${summaryOpen ? ' open' : ''}><summary aria-label="View selected add-ons, sender details and full gift message"><span class="og-gift-summary__addons"><span class="og-gift-summary__thumbs">${thumbs || summaryIcon('gift')}</span><span>${products.length ? `${products.length} Add-on${products.length === 1 ? '' : 's'}` : 'No add-ons'}</span></span><span class="og-gift-summary__inline">${inlineParts.join('<span class="og-gift-summary__divider"></span>')}</span><span class="og-gift-summary__caret" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg></span></summary><div class="og-gift-summary__list"><div class="og-gift-summary__list-title">Selected add-ons</div>${list ? `<ul>${list}</ul>` : '<p class="og-gift-summary__empty-detail">No add-ons selected.</p>'}<div class="og-gift-summary__sender-list"><div class="og-gift-summary__list-title">Sender and gift message</div><dl>${savedDetails}</dl></div></div></details><button type="button" class="og-gift-summary__change" data-og-summary-change>Change</button></div>`;
  };
  const saveCompletedSummary = () => {
    state.completed = hasSavedDetails();
    saveSelection();
    saveSenderSession();
    try { sessionStorage.setItem(summaryKey, JSON.stringify({ completed: state.completed, detailsIncluded: state.detailsIncluded })); } catch (error) {}
    renderSummary();
  };
  const hasSavedDetails = () => {
    const sender = readSenderSession();
    return state.selected.size > 0 || hasSenderContent(sender);
  };
  const releasePurchaseButton = () => {
    const button = state.purchaseButton;
    if (button) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.classList.remove('og-summary-buy-busy');
    }
    state.purchaseButton = null;
  };
  const startPurchase = async (form, button = null) => {
    if (state.adding || state.preparing || !popup.hidden) return;
    state.preparing = true;
    state.purchaseButton = button || $(config.buyButtonSelector, form);
    if (state.purchaseButton) {
      state.purchaseButton.disabled = true;
      state.purchaseButton.setAttribute('aria-busy', 'true');
      state.purchaseButton.classList.add('og-summary-buy-busy');
    }
    try {
      await loadProducts();
      restoreSummarySettings();
      restoreSenderSession();
      renderSummary();
      if (!hasSavedDetails()) {
        releasePurchaseButton();
        await openPopup(form);
        return;
      }
      // Do not open either popup, lock the body or advance popup steps here.
      state.editOnly = false;
      state.activeForm = form;
      state.activeVariantId = getVariantId(form);
      state.activeProductHandle = getCurrentHandle();
      applySenderProperties(state.detailsIncluded);
      await submitFinal();
    } catch (error) {
      releasePurchaseButton();
      window.alert(error.message || 'Unable to continue. Please try again.');
    } finally { state.preparing = false; }
  };
  const restoreSummarySettings = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(summaryKey) || '{}');
      state.completed = saved.completed === true;
      state.detailsIncluded = hasSenderContent(readSenderSession()) || saved.detailsIncluded !== false;
    } catch (error) {}
  };
  restoreSummarySettings();
  restoreSelection();
  restoreSenderSession();
  renderSummary();
  document.addEventListener('shopify:section:load', renderSummary);
  window.addEventListener('storage', event => {
    if (event.key !== senderPersistentKey || !popup.hidden) return;
    restoreSummarySettings();
    restoreSenderSession();
    updateGiftMessageUI();
    renderSummary();
  });
  window.addEventListener('pageshow', () => {
    state.adding = false;
    state.preparing = false;
    releasePurchaseButton();
    restoreSummarySettings();
    restoreSelection();
    restoreSenderSession();
    [els.detailsContinue, els.detailsSkip, els.detailsClose].filter(Boolean).forEach(control => {
      control.removeAttribute('aria-disabled');
      control.removeAttribute('aria-busy');
    });
    els.detailsContinue?.classList.remove('is-processing');
    if (!popup.hidden) hidePopupNow();
    state.editOnly = false;
    setFinalLabel();
    renderSummary();
  });
  window.OGAddonPopup = {
    open: form => startPurchase(form || $(config.productFormSelector)),
    edit: form => openPopup(form || $(config.productFormSelector), true),
    add: submitFinal,
    reload: async () => {
      state.loaded = false;
      state.loadingPromise = null;
      state.productsByCategory.clear();
      await loadProducts();
      render();
    }
  };
  populateOccasionMenu();
  updateGiftMessageUI();
  const warmProductCache = () => {
    const start = () => { void loadProducts().then(renderSummary); };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(start, { timeout: 3000 });
    } else {
      window.setTimeout(start, 1500);
    }
  };
  const boot = () => {
    warmProductCache();
  };
  if (document.readyState === 'complete') {
    boot();
  } else {
    window.addEventListener('load', boot, { once: true });
  }
})();